import userEvent from "@testing-library/user-event";
import React, { useState, useEffect, useRef } from "react";
import {Col, Container, Modal, Row, Form, Spinner, Button } from 'react-bootstrap';
import { useSelector } from "react-redux";
import * as XLSX from 'xlsx';
import GridControl from "../Controls/gridControl";
import ExportIcon from "../../assets/Images/CommonImages/save.png";
import ClearFilterIcon from "../../assets/Images/CommonImages/clearFilter.png";
import ValidateIcon from "../../assets/Images/CommonImages/validateIcon.png";
import AdjustTimes from "../../assets/Images/CommonImages/adjustTimes.png";
import CommitTimes from "../../assets/Images/CommonImages/commitTimes.png";
import infoIcon from "../../assets/Images/CommonImages/info.png";
import selectAllIcon from "../../assets/Images/CommonImages/selectAll.png";
import APICom from "../../utils/helpers/APICom";

const StandingRoutes = (props) => {
    const { ARBResponseForAdjustTime, ARBResponseForValidate} = useSelector((store) => store.ARB);
    const { GlobalASCSData, DispatchVehicleData, FundingSourceData } = useSelector((store) => store.combinedata);
    const { loginData } = useSelector((store) => store.login);
    const [standingRouteStops, setStandingRouteStops] = useState([]);
    const [manageSRStops, setManageSRStops] = useState([]);
    const [SRCreateTableData, setSRCreateTableData] = useState([]);
    const [SRSavedTableData, setSRSavedTableData] = useState([]);
    const [SRManageTableData, setSRManageTableData] = useState([]);
    const [SRCreateTripsData, setSRCreateTripsData] = useState([]);
    const [downloadBtnNames, setDownloadBtnNames] = useState(["Download Route(s)"]);
    const [manageBtnNames, setManageBtnNames] = useState(["Update SR", "Remove Trip(s)/Route", "Update Time", "Edit SR Trip", "PreSchedule"]);
    const [showLoader, setShowLoader] = useState(false);
    const [showStandingRoutePage, setShowStandingRoutePage] = useState(true);
    const [showModal, setShowModal] = useState(false);
    
    const [showSRManagePage, setShowSRManagePage] = useState(false);
    const [showSaveModal, setShowSaveModal] = useState(false);
    const [showPreScheduleModal, setShowPreScheduleModal] = useState(false);
    const [mandVehCheck, setMandVehCheck] = useState(false);
    const [saveModalTitle, setSaveModalTitle] = useState("");
    const [modalBodyHTML, setModalBodyHTML] = useState("");
    const [modalHeaderText, setModalHeaderText] = useState("");
    const [modalBtnHTML, setModalBtnHTML] = useState([]);
    const [vehOptionsManageHTML, setVehOptionsManageHTML] = useState([]);
    const [FSOptionsManageHTML, setFSOptionsManageHTML] = useState([]);
    // const [downloadRouteOptionChecked, setDownloadRouteOptionChecked] = useState("");
    const [showDownloadDialogue, setShowDownloadDialogue] = useState(false);
    const [showUpdateTimeDialog, setShowUpdateTimeDialog] = useState(false);
    const [showEditTripModal, setShowEditTripModal] = useState(false);
    const [showStandingRouteCreatePage, setShowStandingRouteCreatePage] = useState(false);
    const [selectedDate, setSelectedDate] = useState((props.selectedDate.split("-")[0]+"-"+(parseInt(props.selectedDate.split("-")[1])<10?
    "0"+parseInt(props.selectedDate.split("-")[1]):props.selectedDate.split("-")[1])+"-"+(parseInt(props.selectedDate.split("-")[2])<10?
    "0"+parseInt(props.selectedDate.split("-")[2]):props.selectedDate.split("-")[2])));
    const [selectedDateCreate, setSelectedDateCreate] = useState((props.selectedDate.split("-")[0]+"-"+(parseInt(props.selectedDate.split("-")[1])<10?
    "0"+parseInt(props.selectedDate.split("-")[1]):props.selectedDate.split("-")[1])+"-"+(parseInt(props.selectedDate.split("-")[2])<10?
    "0"+parseInt(props.selectedDate.split("-")[2]):props.selectedDate.split("-")[2])));
    const [selectedDateManage, setSelectedDateManage] = useState((props.selectedDate.split("-")[0]+"-"+(parseInt(props.selectedDate.split("-")[1])<10?
    "0"+parseInt(props.selectedDate.split("-")[1]):props.selectedDate.split("-")[1])+"-"+(parseInt(props.selectedDate.split("-")[2])<10?
    "0"+parseInt(props.selectedDate.split("-")[2]):props.selectedDate.split("-")[2])));
    const manualDownloadTitle = useRef(null);
    const manageSRTitle = useRef(null);
    const createSRTitle = useRef(null);
    const saveRouteFromDate = useRef(null);
    const saveRouteEndDate = useRef(null);
    const saveRouteSRType = useRef(null);
    const SRStopsGrid = useRef(null); 
    const ManageStopsGrid = useRef(null); 
    const SRCreateStops = useRef(null);
    const xCancelSourceForGrid = useRef(null);
    const SRrowClickCheck = useRef(null);
    const ManageSRrowClickCreateGridCheckRef = useRef(null);
    const SRrowClickCreateGridCheck = useRef(null);
    const [downloadRouteRadioChecked, setDownloadRouteRadioChecked] = useState(0);

    //----------------------Table Objects
    const downloadSRMainTableObject = useRef(null);
    const downloadSRStopsTableObject = useRef(null);
    const manageSRMainTableObject = useRef(null);
    const manageSRStopsTableObject = useRef(null);
    const createSRMainTableObject = useRef(null);
    const createRouteStopsObject = useRef(null);
    //----------------------
    //----------------------Update SR (Manage)
    const [manageDaysSelected, setManageDaysSelected] = useState({Mon:false,Tue:false,Wed:false,Thu:false,Fri:false,Sat:false,Sun:false});
    const [manageTripDaysSelected, setManageTripDaysSelected] = useState({Mon:false+", ",Tue:false+", ",Wed:false+", ",Thu:false+", ",Fri:false+", ",Sat:false+", ",Sun:false+", "});
    const [disabledDatesManageCheck, setDisabledDatesManageCheck] = useState({Mon:false,Tue:false,Wed:false,Thu:false,Fri:false,Sat:false,Sun:false});
    const [showUpdateSRSettingsModal, setShowUpdateSRSettingsModal] = useState(false);
    const [updateSRInfo, setUpdateSRInfo] = useState({Name:"",Veh:0,From:"01/01/1900",To:"01/01/1900",Auto:false,InsertMissing:false,SRType:"", RouteNo:""});
    const [updateTimeInfoManage, setUpdateTimeInfoManage] = useState({requestedTime:"",SystemTime:""});
    const [editTripInfoManage, setEditTripInfoManage] = useState({Phone:"999-999-9999",Name:"",PUTime:"",ApptTime:"",PUSt:"",PUCity:"",PUState:"",
        PUUnit:"",PUZip:0,PUZone:"",PULat:"",PULng:"",PUSchTime:"",DOSt:"",DOCity:"",DOUnit:"",DOState:"",DOZip:0,DOZone:"",DOLat:"",DOLng:"",DOSchTime:"",
        EstTime:"",EstDist:"",EstCost:"",Copay:"",TotPass:1,TotWC:0,TotChildren:0,FS:""});

    const [violationColors, setViolationColors] = useState([{"capacity":"#FFA500", "timeWindow":"#C6B0F2", "RideTime":"#87CEEB", 
        "maxMilesHours":"#BF8B19", "driverBreak":"#91F895",
        "uniqueStops":"#FA7AFC", "nonDrop":"#FF0000", "puLoopBack":"#F5CAA4","WillCallTrip":"#B2B200","TripStartTime":"#004d80",
        "MaxTrips":"#00ff3e","invalidDOGPS":"#000dff","maxRouteHrs":"#303030","invalidPUGPS":"#05501e", "RideSharing":"#5d00ff"}]);
    //----------------------

    //----------------------Update (Create)
    const [updateCreateInfo, setUpdateCreateInfo] = useState({Name:"",From:"01/01/1900",To:"01/01/1900",Auto:false,InsertMissing:false,SRType:"",route:"",vehicle:""});
    const [CreateDaysSelected, setCreateDaysSelected] = useState({Mon:false,Tue:false,Wed:false,Thu:false,Fri:false,Sat:false,Sun:false});
    //----------------------

    let state = {
        placeholder:"",
        disable:false,
        id:"",
        className:"",
        hidePlaceholder:false,
        styles:{width:"160px",marginLeft:"10px", height: "38px", fontSize: "inherit" },
        initialDate:"now"

    };
    //----------------------------------------------------------------------Saved SR Tables-----------------------------------------------------------------------------
    const [standingRouteGridOptions, setStandingRouteGridOptions] = useState({
        height: 300,
        heightoffset: 600,
        calculateHeight: false,
        pagination: true,
        sortCondition: true,
        paginationMode: "local",
        paginationSize: 100,
        paginationSizeSelector: [100, 200, 300, 400, 500],
        selectable: 1,
        reactiveData:false, //enable data reactivity
        layout: "fitDataStretch",
        placeholder:"No Data Available",
        clipboard: false,
        selectableRangeMode: "click",
        GridName:"standingRoute",
        paginationCounter:"rows",
        intervalTimer: GlobalASCSData.find(dict => dict.SubTitle === "Tb01") === undefined? 60000:GlobalASCSData.find(dict => dict.SubTitle === "Tb01").value*2000,
        movableColumns:true,
        vDefaultGridName: "SelectedGridRouteSRQARQPRQ_New",
        index: "iManifestNumber",
        autoColumns: true,
        bSysUser: 1,
        intervalEnable: false,
        persistence: false,
        bWebApplySettingToAll: true,
        GridReturnOnlyIDColumnInRowData: false,
        containerClass: "col position-relative",
        Containerstyle: {},
        footerElement: '<button class="tabulator_btns" title="Export Excel" id="'
        +"standingRoute"+'_Export"></button><button class="tabulator_btns lastTabulator-btn" '
        +' title="Clear Filters" id="'+"standingRoute"+'_ClearFilters"></button>',
        tableDoubleClickFunc: function(table, row) {
        },
        footerElementHandles: function (table) {
            downloadSRMainTableObject.current = table;
            downloadSRMainTableObject.current.selectRow( downloadSRMainTableObject.current.getData()[0].iManifestNumber);
            var img = document.createElement("img");
                img.style.cssText = "width:16px; height:16px"; 
                img.src = ExportIcon;
                document.getElementById("standingRoute_Export").appendChild(img);

            var img = document.createElement("img");
                img.style.cssText = "width:16px; height:16px"; 
                img.src = ClearFilterIcon;
                document.getElementById("standingRoute_ClearFilters").appendChild(img);

            document.getElementById("standingRoute_Export").addEventListener("click", function(){
                const data = table.getData('active');
                const columnsToIgnore = ['id'];
                var filteredData = data.map(row =>{
                    const filteredRow = {...row};
                    columnsToIgnore.forEach(column => delete filteredRow[column]);
                    return filteredRow;
                });
                
                const sheet = XLSX.utils.json_to_sheet(filteredData);
                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, sheet, "MRMS Data");
                XLSX.writeFile(wb, "standingRouteTable_data.xlsx");
                
            });
            document.getElementById('standingRoute_ClearFilters').addEventListener("click", function(){
                table.clearHeaderFilter();
            });
        },
        rowSelectionChangeHandle: async function(data){  //&& !boxChecked.current
            if(data.length > 0 && data[0].vManifestNumber !== SRrowClickCheck.current)
            {
                SRrowClickCheck.current = data[0].vManifestNumber;
                SRStopsGrid.current.className = "opacity-0 d-block";
                try{
                    let SRData = {
                        "iManifestNumber": parseInt(data[0].iManifestNumber),
                        "vFileName": data[0].Name,
                        "iAffiliateID": data[0].iATSPID
                    };
                    xCancelSourceForGrid.current = APICom.GenerateSource();
                    setShowLoader(true);
                    let response = await APICom.fetchData("GenericManifestDotNetCoreURL","api/StandingRoute/GetStandingRouteStops", "post", {}, SRData, xCancelSourceForGrid.current);
                    if(response.data !== null && response["data"].length > 0)
                    {
                        setStandingRouteStops(response["data"]);
                        SRStopsGrid.current.className = "opacity-100";
                    }
                    else if(response.data !== null && response["data"].length === 0)
                    {
                        SRStopsGrid.current.className = "d-none";
                    }
                    else
                    {
                        SRStopsGrid.current.className = "d-none";
                    }
                    setShowLoader(false);
                    // console.log(response);
                }
                catch(err){console.log(err);}
            }
            
            

        },
        listofCheckBoxCols : ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun", "NA"],
        AlwaysHiddenColumns: ["iManifestNumber", "vManifestNumber", "vDays", "iSettingID", "iRouteEntityTypeID"]
    });
    const [standingRouteStopsGridOptions, setStandingRouteStopsGridOptions] = useState({
        height: 300,
        heightoffset: 600,
        calculateHeight: false,
        pagination: true,
        sortCondition: true,
        paginationMode: "local",
        paginationSize: 100,
        paginationSizeSelector: [100, 200, 300, 400, 500],
        selectable: true,
        reactiveData:false, //enable data reactivity
        layout: "fitDataStretch",
        placeholder:"No Data Available",
        clipboard: false,
        selectableRangeMode: "click",
        GridName:"standingRouteStops",
        paginationCounter:"rows",
        intervalTimer: GlobalASCSData.find(dict => dict.SubTitle === "Tb01") === undefined? 60000:GlobalASCSData.find(dict => dict.SubTitle === "Tb01").value*2000,
        movableColumns:true,
        vDefaultGridName: "SelectedGridRouteSRQARQPRQ_New",
        index: "Name",
        autoColumns: true,
        bSysUser: 1,
        intervalEnable: false,
        persistence: false,
        bWebApplySettingToAll: true,
        GridReturnOnlyIDColumnInRowData: false,
        AlwaysHiddenColumns:["Index","Violation"],
        containerClass: "col position-relative mt-2",
        Containerstyle: {},
        footerElement: '<button class="tabulator_btns" title="Export Excel" id="'
        +"standingRouteStops"+'_Export"></button><button class="tabulator_btns  middleTabulator-btns" title="Select All Rows" id="'
        +"standingRouteStops"+'_SelectAll"></button><button class="tabulator_btns lastTabulator-btn" '
        +' title="Clear Filters" id="'+"standingRouteStops"+'_ClearFilters"></button>',
        tableDoubleClickFunc: function(table, row) {
        },
        footerElementHandles: function (table) {
            downloadSRStopsTableObject.current = table;
            var img = document.createElement("img");
                img.style.cssText = "width:16px; height:16px"; 
                img.src = ExportIcon;
                document.getElementById("standingRouteStops_Export").appendChild(img);

            var img = document.createElement("img");
                img.style.cssText = "width:16px; height:16px"; 
                img.src = ClearFilterIcon;
                document.getElementById("standingRouteStops_ClearFilters").appendChild(img);

            var img = document.createElement("img");
                img.style.cssText = "width:16px; height:16px"; 
                img.src = selectAllIcon;
                document.getElementById("standingRouteStops_SelectAll").appendChild(img);
            document.getElementById("standingRouteStops_Export").addEventListener("click", function(){
                const data = table.getData('active');
                const columnsToIgnore = ['id'];
                var filteredData = data.map(row =>{
                    const filteredRow = {...row};
                    columnsToIgnore.forEach(column => delete filteredRow[column]);
                    return filteredRow;
                });
                
                const sheet = XLSX.utils.json_to_sheet(filteredData);
                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, sheet, "MRMS Data");
                XLSX.writeFile(wb, "standingRouteStops_data.xlsx");
                
            });
            document.getElementById('standingRouteStops_ClearFilters').addEventListener("click", function(){
                table.clearHeaderFilter();
            });
            document.getElementById('standingRouteStops_SelectAll').addEventListener("click", function(){
                table.selectRow();
            });
        },
        rowSelectionChangeHandle: function(data){

        },
    });
    //-------------------------------------------------------------------------------------------------------------------------------------------------------------------------
    //----------------------------------------------------------------------SR Manage Tables-----------------------------------------------------------------------------------
    const [manageSRGridOptions, setManageSRGridOptions] = useState({
        height: 300,
        heightoffset: 600,
        calculateHeight: true,
        pagination: true,
        sortCondition: true,
        paginationMode: "local",
        paginationSize: 500,
        paginationSizeSelector: [500, 1000, 1500, 2000, 2500],
        selectable: 1,
        reactiveData:false, //enable data reactivity
        layout: "fitDataStretch",
        placeholder:"No Data Available",
        clipboard: false,
        selectableRangeMode: "click",
        GridName:"manageSR",
        paginationCounter:"rows",
        intervalTimer: GlobalASCSData.find(dict => dict.SubTitle === "Tb01") === undefined? 60000:GlobalASCSData.find(dict => dict.SubTitle === "Tb01").value*2000,
        movableColumns:true,
        vDefaultGridName: "SelectedGridRouteSRQARQPRQ_New",
        index: "iManifestNumber",
        autoColumns: true,
        bSysUser: 1,
        intervalEnable: false,
        persistence: false,
        bWebApplySettingToAll: true,
        GridReturnOnlyIDColumnInRowData: false,
        containerClass: "col position-relative",
        Containerstyle: {},
        footerElement: '<button class="tabulator_btns" title="Export Excel" id="'
        +"manageSR"+'_Export"></button><button class="tabulator_btns lastTabulator-btn" '
        +' title="Clear Filters" id="'+"manageSR"+'_ClearFilters"></button>',
        tableDoubleClickFunc: function(table, row) {
        },
        footerElementHandles: function (table) {
            manageSRMainTableObject.current = table;
            manageSRMainTableObject.current.selectRow( manageSRMainTableObject.current.getData()[0].iManifestNumber);
            var img = document.createElement("img");
                img.style.cssText = "width:16px; height:16px"; 
                img.src = ExportIcon;
                document.getElementById("manageSR_Export").appendChild(img);

            var img = document.createElement("img");
                img.style.cssText = "width:16px; height:16px"; 
                img.src = ClearFilterIcon;
                document.getElementById("manageSR_ClearFilters").appendChild(img);

            document.getElementById("manageSR_Export").addEventListener("click", function(){
                const data = table.getData('active');
                const columnsToIgnore = ['id'];
                var filteredData = data.map(row =>{
                    const filteredRow = {...row};
                    columnsToIgnore.forEach(column => delete filteredRow[column]);
                    return filteredRow;
                });
                
                const sheet = XLSX.utils.json_to_sheet(filteredData);
                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, sheet, "MRMS Data");
                XLSX.writeFile(wb, "manageSRTable_data.xlsx");
                
            });
            document.getElementById('manageSR_ClearFilters').addEventListener("click", function(){
                table.clearHeaderFilter();
            });
        },
        rowSelectionChangeHandle: async function(data){ 
            if(data.length > 0 && data[0].vManifestNumber !== ManageSRrowClickCreateGridCheckRef.current)
            {
                ManageSRrowClickCreateGridCheckRef.current = data[0].vManifestNumber;
                ManageStopsGrid.current.className = "opacity-0 d-block";
                await initializeSRStopsTableManage(data[0]);
            }
            
            

        },
        listofCheckBoxCols : ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun", "check"],
        AlwaysHiddenColumns: ["iManifestNumber", "vManifestNumber", "vDays", "iSettingID", "iRouteEntityTypeID"]
    });
    const [manageSRStopOrderGridOptions, setManageSRStopOrderGridOptions] = useState({
        height: 300,
        heightoffset: 600,
        calculateHeight: false,
        pagination: true,
        sortCondition: false,
        paginationMode: "local",
        paginationSize: 500,
        paginationSizeSelector: [500, 1000, 1500, 2000, 2500],
        selectable: true,
        reactiveData:false, //enable data reactivity
        layout: "fitDataStretch",
        placeholder:"No Data Available",
        clipboard: false,
        movableRows: true,
        selectableRangeMode: "click",
        GridName:"manageStopOrder",
        paginationCounter:"rows",
        intervalTimer: GlobalASCSData.find(dict => dict.SubTitle === "Tb01") === undefined? 60000:GlobalASCSData.find(dict => dict.SubTitle === "Tb01").value*2000,
        movableColumns:true,
        vDefaultGridName: "SelectedGridRouteSRQARQPRQ_New",
        index: "Index",
        autoColumns: true,
        bSysUser: 1,
        intervalEnable: false,
        persistence: false,
        bWebApplySettingToAll: true,
        GridReturnOnlyIDColumnInRowData: false,
        AlwaysHiddenColumns:["Index"],
        containerClass: "col position-relative mt-2",
        Containerstyle: {},
        footerElement: '<button class="tabulator_btns" title="Export Excel" id="'
        +"manageStopOrder"+'_Export"></button><button class="tabulator_btns middleTabulator-btns" '
        +' title="Clear Filters" id="'+"manageStopOrder"+'_ClearFilters"></button>'
        +'<button class="tabulator_btns middleTabulator-btns" '
        +' title="Adjust Times & Validate SR" id="'+"manageStopOrder"+'_AdjustTimes"></button>'
        +'<button class="tabulator_btns middleTabulator-btns" '
        +' title="Validate SR" id="'+"manageStopOrder"+'_validate"></button><button class="tabulator_btns middleTabulator-btns" '
        +' title="Commit Changes" id="'+"manageStopOrder"+'_Commit"></button>'
        +'<button class="tabulator_btns lastTabulator-btn" '
        +' title="Display Violations Legend" id="'+"manageStopOrder"+'_infoViolations"></button>',
        tableDoubleClickFunc: function(table, row) {
        },
        footerElementHandles: function (table) {
            manageSRStopsTableObject.current = table;
            var img = document.createElement("img");
                img.style.cssText = "width:16px; height:16px"; 
                img.src = ExportIcon;
                document.getElementById("manageStopOrder_Export").appendChild(img);

            var img = document.createElement("img");
                img.style.cssText = "width:16px; height:16px"; 
                img.src = ClearFilterIcon;
                document.getElementById("manageStopOrder_ClearFilters").appendChild(img);

            var img = document.createElement("img");
                img.style.cssText = "width:16px; height:16px"; 
                img.src = ValidateIcon;
                document.getElementById("manageStopOrder_validate").appendChild(img);

            var img = document.createElement("img");
                img.style.cssText = "width:16px; height:16px"; 
                img.src = CommitTimes;
                document.getElementById("manageStopOrder_Commit").appendChild(img);

            var img = document.createElement("img");
                img.style.cssText = "width:16px; height:16px"; 
                img.src = AdjustTimes;
                document.getElementById("manageStopOrder_AdjustTimes").appendChild(img);
                
            var img = document.createElement("img");
                img.style.cssText = "width:16px; height:16px"; 
                img.src = infoIcon;
                document.getElementById("manageStopOrder_infoViolations").appendChild(img);
            
            document.getElementById("manageStopOrder_Export").addEventListener("click", function(){
                const data = table.getData('active');
                const columnsToIgnore = ['id'];
                var filteredData = data.map(row =>{
                    const filteredRow = {...row};
                    columnsToIgnore.forEach(column => delete filteredRow[column]);
                    return filteredRow;
                });
                
                const sheet = XLSX.utils.json_to_sheet(filteredData);
                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, sheet, "MRMS Data");
                XLSX.writeFile(wb, "manageStopOrder_data.xlsx");
                
            });
            document.getElementById('manageStopOrder_ClearFilters').addEventListener("click", function(){
                table.clearHeaderFilter();
            });
            document.getElementById('manageStopOrder_AdjustTimes').addEventListener("click", async function(){
                AdjustStandingRoute();
            });
            document.getElementById('manageStopOrder_validate').addEventListener("click", async function(){
               ValidateStandingRoute();
            });
            document.getElementById('manageStopOrder_Commit').addEventListener("click", async function(){
              CommitAction();
            });
            document.getElementById('manageStopOrder_infoViolations').addEventListener("click", function(e){
                let manageRouteFooterBtns = ["Close"];
                let manageRouteFooterHTML = manageRouteFooterBtns.map(function(item, index){
                    return(
                        <Button key={index} value={item} variant="secondary" className="mx-2 border-0" onClick={handleModalClose}>
                            {item}
                        </Button>
                    );
                });
                let manageBodyHTML = function(index){
                    return(
                        <Row key={index} className="border rounded p-1">
                            <Col>
                                <p className="m-0 user-select-none text-nowrap" style={{fontSize:"small"}}>{"Capacity(CV):"}</p>
                                <p className="m-0 user-select-none text-nowrap" style={{fontSize:"small"}}>{"Time Window(TWV):"}</p>
                                <p className="m-0 user-select-none text-nowrap" style={{fontSize:"small"}}>{"Ride Time(RTV):"}</p>
                                <p className="m-0 user-select-none text-nowrap" style={{fontSize:"small"}}>{"Max Miles(MMV):"}</p>
                                <p className="m-0 user-select-none text-nowrap" style={{fontSize:"small"}}>{"Driver Break(DBV):"}</p>
                                <p className="m-0 user-select-none text-nowrap" style={{fontSize:"small"}}>{"Unique Stops(USV):"}</p>
                            </Col>
                            <Col>
                                <div className="mt-1" style={{height:"16px", width:"16px", background:violationColors[0].capacity}}></div>
                                <div className="mt-1" style={{height:"16px", width:"16px", background:violationColors[0].timeWindow}}></div>
                                <div className="mt-1" style={{height:"16px", width:"16px", background:violationColors[0].RideTime}}></div>
                                <div className="mt-1" style={{height:"16px", width:"16px", background:violationColors[0].maxMilesHours}}></div>
                                <div className="mt-1" style={{height:"16px", width:"16px", background:violationColors[0].driverBreak}}></div>
                                <div className="mt-1" style={{height:"16px", width:"16px", background:violationColors[0].uniqueStops}}></div>
                            </Col>
                            <Col>
                                <p className="m-0 user-select-none text-nowrap" style={{fontSize:"small"}}>{"Non Drop(NDV):"}</p>
                                <p className="m-0 user-select-none text-nowrap" style={{fontSize:"small"}}>{"Pickup Loop Back(PLV):"}</p>
                                <p className="m-0 user-select-none text-nowrap" style={{fontSize:"small"}}>{"Will Call Trips(WCV):"}</p>
                                <p className="m-0 user-select-none text-nowrap" style={{fontSize:"small"}}>{"Route Start Time(EST):"}</p>
                                <p className="m-0 user-select-none text-nowrap" style={{fontSize:"small"}}>{"Max Trips(MTV):"}</p>
                                <p className="m-0 user-select-none text-nowrap" style={{fontSize:"small"}}>{"Invalid DO GPS(DGDSV):"}</p>
                            </Col>
                            <Col>
                                <div className="mt-1" style={{height:"16px", width:"16px", background:violationColors[0].nonDrop}}></div>
                                <div className="mt-1" style={{height:"16px", width:"16px", background:violationColors[0].puLoopBack}}></div>
                                <div className="mt-1" style={{height:"16px", width:"16px", background:violationColors[0].WillCallTrip}}></div>
                                <div className="mt-1" style={{height:"16px", width:"16px", background:violationColors[0].TripStartTime}}></div>
                                <div className="mt-1" style={{height:"16px", width:"16px", background:violationColors[0].MaxTrips}}></div>
                                <div className="mt-1" style={{height:"16px", width:"16px", background:violationColors[0].invalidDOGPS}}></div>
                            </Col>
                            <Row>
                                <Col xs={4}>
                                    <p className="m-0 user-select-none text-nowrap" style={{fontSize:"small"}}>{"Max Route Hours(RHV):"}</p>
                                    <p className="m-0 user-select-none text-nowrap" style={{fontSize:"small"}}>{"Invalid PU GPS(PGPSV):"}</p>
                                    <p className="m-0 user-select-none text-nowrap" style={{fontSize:"small"}}>{"Ride Sharing(RSV):"}</p>
                                </Col>
                                <Col xs={8} style={{marginLeft:"-6.2%"}}>
                                    <div className="mt-1" style={{height:"16px", width:"16px", background:violationColors[0].maxRouteHrs}}></div>
                                    <div className="mt-1" style={{height:"16px", width:"16px", background:violationColors[0].invalidPUGPS}}></div>
                                    <div className="mt-1" style={{height:"16px", width:"16px", background:violationColors[0].RideSharing}}></div>
                                </Col>
                            </Row>
                        </Row>
                        
                    );
                };
                setModalHeaderText("Violations Legend");
                setModalBodyHTML(manageBodyHTML);
                setModalBtnHTML(manageRouteFooterHTML);
                setShowModal(true);
            });
        },
        rowSelectionChangeHandle: function(data){

        },
        ActionList: true,
        ArrangeClusterTripsErrorCases: [{"TripAtTop":"Trip is already at the top.", "TripAtBottom":"Trip is already at the bottom.", 
        "PUAfterDO": "Pickup can't come after its Dropoff!", "DOBeforePU":"Dropoff can't come before its Pickup!",
        "PrevRowNotExist":"Action not allowed because no previous row exist", "PrevDepotTrip":"Action not allowed because previous trip is depot trip",
        "PrevWillCallTrip":"Action not allowed because previous trip is a will call trip", "PerformedStops":"Action not allowed because trip has already been performed",
        "PrevPerformedStop":"Action not allowed because previous trip has already been performed",
        "PrevBreakTrip":"Action not allowed because previous trip is a break trip", "NextDepotTrip":"Action not allowed because next trip is depot trip",
        "NextvWillCallTrip":"Action not allowed because next trip is a will call trip","NextBreakTrip":"Action not allowed because next trip is a break trip",
        "NextPerformedStop":"Action not allowed because next trip has already been performed"
        }],
        GeneralArrayForHTML : ["Violation"]
    });

    const AdjustStandingRoute = async () =>{
        props.setSRProgressBar();
        let manageMainData = manageSRMainTableObject.current.getSelectedData()[0];
        const data = manageSRStopsTableObject.current.getData('active');
        let _tripDetails = [];
        let _stopOrder = 1;
        for (var i = 0; i < data.length; i++) {
            if (data[i].Type == "PU" || data[i].Type == "DO") {
                let det = {};
                det.RouteID = data[i].Route;
                det.iRefID = data[i]["TripNo"];
                if (det.iRefID == "" || det.iRefID == null || det.iRefID == undefined) {
                    det.iRefID = "-1"
                }
                det.NodeType = data[i].Type;
                det.SystemScheduleTime = data[i]["SysSch Time"];
                det.EstTravelTime = (data[i].EstTime == "" ? 0 : data[i].EstTime);
                det.EstTravelDistance = (data[i].EstDist == "" ? 0 :data[i].EstDist) ;
                det.WaitTimeAtLocation = 0;
                det.PUPerson = data[i].Name;
                det.TripRequestStatus = "";
                det.ERSASettingName = "";
                det.ERSASettingID = _stopOrder; 
                det.Zone = "";
                det.isFeasibleRoute = false;
                det.PickupDateTime = data[i].pickupDateTime;
                det.ManifestNumber = manageMainData.vManifestNumber;
                _tripDetails.push(det);
                _stopOrder++;
            }
        }
        if (_tripDetails.length == 1) {
            let manageRouteFooterBtns = ["OK"];
            let manageRouteFooterHTML = manageRouteFooterBtns.map(function(item, index){
                return(
                    <Button key={index} value={item} className="activate_btn_ok mx-2 border-0" onClick={handleModalClose}>
                        {item}
                    </Button>
                );
            });
            setModalHeaderText("Standing Route");
            setModalBodyHTML("Action not allowed.");
            setModalBtnHTML(manageRouteFooterHTML);
            setShowModal(true);
            return false;
        }
        
        let callBackURL = "";
        if (GlobalASCSData !== null && GlobalASCSData !== undefined) {
            const jsonArray = GlobalASCSData;
            const URL = jsonArray.find(item => item.SubTitle === "AsteriskServerToClientCommAPI_URL");
            callBackURL = URL.value + '/WMRMSCommonAPI/SendMessageToWMRMS';
        }
        let SRData = {
            "TripDetails" : JSON.stringify(_tripDetails),
            "callBackURL" : callBackURL,
            "iMode" : 11, // 11 for Adjust time
            "AlgoSetting" : String(manageMainData.iSettingID),
            "RouteNo" : manageMainData["Route#"],
            "iAffiliateID": manageMainData.iATSPID,
            "iUserID": loginData.iUserID
        }
        
        xCancelSourceForGrid.current = APICom.GenerateSource();
        setShowLoader(true);
        let response = await APICom.fetchData("GenericManifestDotNetCoreURL","api/Routing/BulkInputToARB", "post", {}, SRData, xCancelSourceForGrid.current);
        if(response["data"] !== null && response["data"].length > 0){
              //TO DO
            if (response["data"][0].Result == -1 && response["data"][0].Error && response["data"][0].Error.includes("system")) {
                let downloadRouteFooterBtns = ["OK"];
                let downloadRouteFooterHTML = downloadRouteFooterBtns.map(function (item, index) {
                    return (
                        <Button key={index} value={item} className="activate_btn_ok mx-2 border-0"
                                onClick={handleModalClose}>
                            {item}
                        </Button>
                    );
                });
                setModalHeaderText("Alert");
                setModalBodyHTML(response["data"][0].Error);
                setModalBtnHTML(downloadRouteFooterHTML);
                setShowModal(true);
            }
        }
        else{
            let manageRouteFooterBtns = ["OK"];
            let manageRouteFooterHTML = manageRouteFooterBtns.map(function(item, index){
                return(
                    <Button key={index} value={item} className="activate_btn_ok mx-2 border-0" onClick={handleModalClose}>
                        {item}
                    </Button>
                );
            });
            setModalHeaderText("Standing Route");
            setModalBodyHTML("There is an issue with Adjust Times");
            setModalBtnHTML(manageRouteFooterHTML);
            setShowModal(true);
        }
        setShowLoader(false);
    }

    const ValidateStandingRoute = async () =>{
        props.setSRProgressBar();
         //let manageMainData = manageSRMainTableObject.current.getSelectedRows()[0].getData();
         let manageMainData = manageSRMainTableObject.current.getSelectedData()[0];
         const data = manageSRStopsTableObject.current.getData('active');
         let _tripDetails = [];
         let _stopOrder = 1;
         for (var i = 0; i < data.length; i++) {
             if (data[i].Type == "PU" || data[i].Type == "DO") {
                 let det = {};
                 det.RouteID = data[i].Route;
                 det.iRefID = data[i]["TripNo"];
                 if (det.iRefID == "" || det.iRefID == null || det.iRefID == undefined) {
                     det.iRefID = "-1"
                 }
                 det.NodeType = data[i].Type;
                 det.SystemScheduleTime = data[i]["SysSch Time"];
                 det.EstTravelTime = (data[i].EstTime == "" ? 0 : data[i].EstTime);
                 det.EstTravelDistance = (data[i].EstDist == "" ? 0 : data[i].EstDist) ;
                 det.WaitTimeAtLocation = 0;
                 det.PUPerson = data[i].Name;
                 det.TripRequestStatus = "";
                 det.ERSASettingName = "";
                 det.ERSASettingID = _stopOrder; 
                 det.Zone = "";
                 det.isFeasibleRoute = false;
                 det.PickupDateTime = data[i].pickupDateTime;
                 det.ManifestNumber = manageMainData.vManifestNumber;
                 _tripDetails.push(det);
                 _stopOrder++;
             }
         }
         if (_tripDetails.length == 1) {
            let manageRouteFooterBtns = ["OK"];
            let manageRouteFooterHTML = manageRouteFooterBtns.map(function(item, index){
                return(
                    <Button key={index} value={item} className="activate_btn_ok mx-2 border-0" onClick={handleModalClose}>
                        {item}
                    </Button>
                );
            });
            setModalHeaderText("Standing Route");
            setModalBodyHTML("Action not allowed.");
            setModalBtnHTML(manageRouteFooterHTML);
            setShowModal(true);
            return false;
         }
         
         let callBackURL = "";
         if (GlobalASCSData !== null && GlobalASCSData !== undefined) {
             const jsonArray = GlobalASCSData;
             const URL = jsonArray.find(item => item.SubTitle === "AsteriskServerToClientCommAPI_URL");
             callBackURL = URL.value + '/WMRMSCommonAPI/SendMessageToWMRMS';
         }

         let SRData = {
             "TripDetails" : JSON.stringify(_tripDetails),
             "callBackURL" : callBackURL,
             "iMode" : 12, // 12 for Validate ROute
             "AlgoSetting" : String(manageMainData.iSettingID),
             "RouteNo" : manageMainData["Route#"],
             "iAffiliateID": manageMainData.iATSPID,
             "iUserID": loginData.iUserID
         }
         
         xCancelSourceForGrid.current = APICom.GenerateSource();
         setShowLoader(true);
         let response = await APICom.fetchData("GenericManifestDotNetCoreURL","api/Routing/BulkInputToARB", "post", {}, SRData, xCancelSourceForGrid.current);
         if(response["data"] !== null && response["data"].length > 0){
             if (response["data"][0].Result == -1 && response["data"][0].Error && response["data"][0].Error.includes("system")) {
                let downloadRouteFooterBtns = ["OK"];
                let downloadRouteFooterHTML = downloadRouteFooterBtns.map(function (item, index) {
                    return (
                        <Button key={index} value={item} className="activate_btn_ok mx-2 border-0"
                                onClick={handleModalClose}>
                            {item}
                        </Button>
                    );
                });
                setModalHeaderText("Alert");
                setModalBodyHTML(response["data"][0].Error);
                setModalBtnHTML(downloadRouteFooterHTML);
                setShowModal(true);
            }
         }
         else{
            let manageRouteFooterBtns = ["OK"];
            let manageRouteFooterHTML = manageRouteFooterBtns.map(function(item, index){
                return(
                    <Button key={index} value={item} className="activate_btn_ok mx-2 border-0" onClick={handleModalClose}>
                        {item}
                    </Button>
                );
            });
            setModalHeaderText("Standing Route");
            setModalBodyHTML("There is an issue with Validate Standing Route");
            setModalBtnHTML(manageRouteFooterHTML);
         }
         setShowLoader(false);
    }

    const CommitAction = async () => {
        let originalTableData = manageSRStopsTableObject.current.getData();
        if (originalTableData.length > 0) {
            let _iStopNumberCount = 1;
            let finalResponse = "";
            for (var i = 0; i < originalTableData.length; i++) {
                var _ConfirmationNo = originalTableData[i]["TripNo"];
                var _stoptype = originalTableData[i]["Type"];
                if (_ConfirmationNo != "" && (_stoptype == "PU" || _stoptype == "DO")) {
                    finalResponse += originalTableData[i]["TripNo"] + "!" + _iStopNumberCount + "!" + _stoptype + "!" + (originalTableData[i]["EstDist"] == "" ? 0:originalTableData[i]["EstDist"]) + "!" + (originalTableData[i]["EstTime"] == "" ? 0: originalTableData[i]["EstTime"]) + "!" + originalTableData[i]["SysSch Time"] + ",";
                    _iStopNumberCount++;
                }
            }
            let SRData = {
                "stopData" : finalResponse
            }
            xCancelSourceForGrid.current = APICom.GenerateSource();
            setShowLoader(true);
            let response = await APICom.fetchData("GenericManifestDotNetCoreURL","api/StandingRoute/CommitStopOrder", "post", {}, SRData, xCancelSourceForGrid.current);
            if(response["data"] !== null && response["data"].length > 0){
                let manageRouteFooterBtns = ["OK"];
                let manageRouteFooterHTML = manageRouteFooterBtns.map(function(item, index){
                return(
                    <Button key={index} value={item} className="activate_btn_ok mx-2 border-0" onClick={handleModalClose}>
                        {item}
                    </Button>
                );
            });
            setModalHeaderText("Standing Route");
            setModalBodyHTML("Trip Data Saved Successfully");
            setModalBtnHTML(manageRouteFooterHTML);
            setShowModal(true);
            setShowLoader(false);
            }
        }
    }

    function ChangeStopOrder() {
        try {
            let value = 0;
            let array = manageSRStopsTableObject.current.getData();
            for (var k = 1; k < array.length; k++) {
                value = value + 1;
                manageSRStopsTableObject.current.updateRow(array[k]['Index'], {["StopOrder"]:value});
            }
        }
        catch (ChangeStopOrder) { console.log(ChangeStopOrder); }
    }

    //-------------------------------------------------------------------------------------------------------------------------------------------------------------------------
    //----------------------------------------------------------------------New SR Tables (Create)-----------------------------------------------------------------------------
    const [SRCreateGridOptions, setSRCreateGridOptions] = useState({
        height: 300,
        heightoffset: 600,
        calculateHeight: false,
        pagination: true,
        sortCondition: true,
        paginationMode: "local",
        paginationSize: 500,
        paginationSizeSelector: [500, 1000, 1500, 2000, 2500],
        selectable: 1,
        reactiveData:false, //enable data reactivity
        layout: "fitDataStretch",
        placeholder:"No Data Available",
        clipboard: false,
        selectableRangeMode: "click",
        GridName:"SRCreate",
        paginationCounter:"rows",
        intervalTimer: GlobalASCSData.find(dict => dict.SubTitle === "Tb01") === undefined? 60000:GlobalASCSData.find(dict => dict.SubTitle === "Tb01").value*2000,
        movableColumns:true,
        vDefaultGridName: "SelectedGridRouteSRQARQPRQ_New",
        index: "ID",
        autoColumns: true,
        bSysUser: 1,
        intervalEnable: false,
        persistence: false,
        bWebApplySettingToAll: true,
        GridReturnOnlyIDColumnInRowData: false,
        containerClass: "col position-relative",
        Containerstyle: {},
        footerElement: '<button class="tabulator_btns" title="Export Excel" id="'
        +"SRCreate"+'_Export"></button><button class="tabulator_btns lastTabulator-btn" '
        +' title="Clear Filters" id="'+"SRCreate"+'_ClearFilters"></button>',
        tableDoubleClickFunc: function(table, row) {
        },
        footerElementHandles: function (table) {
            createSRMainTableObject.current = table;
            createSRMainTableObject.current.selectRow( createSRMainTableObject.current.getData()[0].ID);
            var img = document.createElement("img");
                img.style.cssText = "width:16px; height:16px"; 
                img.src = ExportIcon;
                document.getElementById("SRCreate_Export").appendChild(img);

            var img = document.createElement("img");
                img.style.cssText = "width:16px; height:16px"; 
                img.src = ClearFilterIcon;
                document.getElementById("SRCreate_ClearFilters").appendChild(img);

            document.getElementById("SRCreate_Export").addEventListener("click", function(){
                const data = table.getData('active');
                const columnsToIgnore = ['id'];
                var filteredData = data.map(row =>{
                    const filteredRow = {...row};
                    columnsToIgnore.forEach(column => delete filteredRow[column]);
                    return filteredRow;
                });
                
                const sheet = XLSX.utils.json_to_sheet(filteredData);
                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, sheet, "MRMS Data");
                XLSX.writeFile(wb, "SRCreateTable_data.xlsx");
                
            });
            document.getElementById('SRCreate_ClearFilters').addEventListener("click", function(){
                table.clearHeaderFilter();
            });
        },
        rowSelectionChangeHandle: async function(data){  //&& !boxChecked.current
            
            if(data.length > 0 && data[0]["Route#"] !== SRrowClickCreateGridCheck.current["Route#"])
            {
                SRrowClickCreateGridCheck.current = data[0];
                if(data[0]["SR Name"] === "" || data[0]["SR Name"] === null)
                {
                    document.getElementById("CreateBtn").disabled = false;
                    document.getElementById("UpdateBtn_CreatePg").disabled = true;
                }
                else
                {
                    document.getElementById("CreateBtn").disabled = true;
                    document.getElementById("UpdateBtn_CreatePg").disabled = false;
                }
                SRCreateStops.current.className = "opacity-0 d-block";
                try{
                    let SRData = {
                        "vManifestNumber": data[0].ManifestNumber,
                        "vAffIDs": String(data[0].ATSPID), //String(data[0].ATSPID),
                    };
                    xCancelSourceForGrid.current = APICom.GenerateSource();
                    setShowLoader(true);
                    let response = await APICom.fetchData("GenericManifestDotNetCoreURL","api/StandingRoute/GetRouteNodeViewForSR", "post", {}, SRData, xCancelSourceForGrid.current);
                    if(response.data !== null && response["data"].length > 0)
                    {
                        setSRCreateTripsData(response["data"]);
                        SRCreateStops.current.className = "opacity-100";
                    }
                    else if(response.data !== null && response["data"].length === 0)
                    {
                        SRCreateStops.current.className = "d-none";
                    }
                    else
                    {
                        SRCreateStops.current.className = "d-none";
                    }
                    // console.log(response);
                    setShowLoader(false);
                }
                catch(err){console.log(err);}
            }
            

        },
        listofCheckBoxCols : ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun", "NA"],
        AlwaysHiddenColumns: ["ID", "ManifestNumber", "iStandingRouteID", "iRouteEntityTypeID"]
    });

    const [SRCreateStopsGridOptions, setSRCreateStopsGridOptions] = useState({
        height: 300,
        heightoffset: 600,
        calculateHeight: false,
        pagination: true,
        sortCondition: true,
        paginationMode: "local",
        paginationSize: 500,
        paginationSizeSelector: [500, 1000, 1500, 2000, 2500],
        selectable: true,
        reactiveData:false, //enable data reactivity
        layout: "fitDataStretch",
        placeholder:"No Data Available",
        clipboard: false,
        selectableRangeMode: "click",
        GridName:"SRCreateStops",
        paginationCounter:"rows",
        intervalTimer: GlobalASCSData.find(dict => dict.SubTitle === "Tb01") === undefined? 60000:GlobalASCSData.find(dict => dict.SubTitle === "Tb01").value*2000,
        movableColumns:true,
        vDefaultGridName: "SelectedGridRouteSRQARQPRQ_New",
        index: "Confirmation#",
        autoColumns: true,
        bSysUser: 1,
        intervalEnable: false,
        persistence: false,
        bWebApplySettingToAll: true,
        GridReturnOnlyIDColumnInRowData: false,
        AlwaysHiddenColumns:[],
        containerClass: "col position-relative mt-2",
        Containerstyle: {},
        footerElement: '<button class="tabulator_btns" title="Export Excel" id="'
        +"SRCreateStops"+'_Export"></button><button class="tabulator_btns  middleTabulator-btns" title="Select All Rows" id="'
        +"SRCreateStops"+'_SelectAll"></button><button class="tabulator_btns lastTabulator-btn" '
        +' title="Clear Filters" id="'+"SRCreateStops"+'_ClearFilters"></button>',
        tableDoubleClickFunc: function(table, row) {
        },
        footerElementHandles: function (table) {
            createRouteStopsObject.current = table;
            var img = document.createElement("img");
                img.style.cssText = "width:16px; height:16px"; 
                img.src = ExportIcon;
                document.getElementById("SRCreateStops_Export").appendChild(img);

            var img = document.createElement("img");
                img.style.cssText = "width:16px; height:16px"; 
                img.src = ClearFilterIcon;
                document.getElementById("SRCreateStops_ClearFilters").appendChild(img);
            
            var img = document.createElement("img");
                img.style.cssText = "width:16px; height:16px"; 
                img.src = selectAllIcon;
                document.getElementById("SRCreateStops_SelectAll").appendChild(img);
            document.getElementById("SRCreateStops_Export").addEventListener("click", function(){
                const data = table.getData('active');
                const columnsToIgnore = ['id'];
                var filteredData = data.map(row =>{
                    const filteredRow = {...row};
                    columnsToIgnore.forEach(column => delete filteredRow[column]);
                    return filteredRow;
                });
                
                const sheet = XLSX.utils.json_to_sheet(filteredData);
                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, sheet, "MRMS Data");
                XLSX.writeFile(wb, "SRCreateStops_data.xlsx");
                
            });
            document.getElementById('SRCreateStops_ClearFilters').addEventListener("click", function(){
                table.clearHeaderFilter();
            });
            document.getElementById('SRCreateStops_SelectAll').addEventListener("click", function(){
                table.selectRow();
            });
        },
        rowSelectionChangeHandle: async function(data){  //headerFilter:"tickCross"
        },
        rowColoring: [{col:"SRTypeStatus", color:"gray"}]
    });
    //-------------------------------------------------------------------------------------------------------------------------------------------------------------------------
    
    const handleClose = () =>  props.setStandingRouteDialog(false);
    const handleModalClose = () => {
        setShowModal(false);
    };
    const initializeSRTable = async (date) =>{
        try{
            if(SRStopsGrid.current !== null)
            {
                SRStopsGrid.current.className = "d-none";
            }
            SRrowClickCheck.current = "";
            let SRData = {
                "dtReqDate": date === '' ? selectedDate:date,
                "vAffIDs": props.selectedAffiliates//props.selectedAffiliates
            };
            xCancelSourceForGrid.current = APICom.GenerateSource();
            setShowLoader(true);
            let response = await APICom.fetchData("GenericManifestDotNetCoreURL","api/StandingRoute/GetSavedSRForSelectedDate", "post", {}, SRData, xCancelSourceForGrid.current);
            if(response["data"] !== null && response["data"].length > 0)
            {
                setSRSavedTableData(response["data"]);
            }
            else
            {
                setSRSavedTableData([]);
            }
            setShowLoader(false);
            // console.log(response);
        }
        catch(err){console.log(err);}
    }

    const initializeSRTableManage = async (date) =>{
        try{
            if(ManageStopsGrid.current !== null)
            {
                ManageStopsGrid.current.className = "d-none";
            }
            ManageSRrowClickCreateGridCheckRef.current = "";
            let SRData = {
                "dtReqDate": date === '' ? selectedDateManage:date,
                "vAffIDs": props.selectedAffiliates//props.selectedAffiliates
            };
            xCancelSourceForGrid.current = APICom.GenerateSource();
            setShowLoader(true);
            let response = await APICom.fetchData("GenericManifestDotNetCoreURL","api/StandingRoute/GetSavedStandingRoutes", "post", {}, SRData, xCancelSourceForGrid.current);
            if(response["data"]!== null && response["data"].length > 0)
            {
                setSRManageTableData(response["data"]);
                // console.log(response);
            }
            else
            {
                setSRManageTableData([]);
            }
            setShowLoader(false);
            // console.log(response);
        }
        catch(err){console.log(err);}
    }

    const initializeSRStopsTableManage = async (data)=>{
        try{
            let SRData = {
                "iManifestNumber": parseInt(data.iManifestNumber),
                "vFileName": data.Name,
                "iAffiliateID": data.iATSPID
            };
            xCancelSourceForGrid.current = APICom.GenerateSource();
            setShowLoader(true);
            let response = await APICom.fetchData("GenericManifestDotNetCoreURL","api/StandingRoute/GetStandingRouteStops", "post", {}, SRData, xCancelSourceForGrid.current);
            if(response.data !== null && response["data"].length > 0)
            {
                setManageSRStops(response["data"]);
                ManageStopsGrid.current.className = "opacity-100";
            }
            else if(response.data !== null && response["data"].length === 0)
            {
                ManageStopsGrid.current.className = "d-none";
            }
            else
            {
                ManageStopsGrid.current.className = "d-none";
            }
            // console.log(response);
            setShowLoader(false);
        }
        catch(err){console.log(err);}
    }

    const initializeSRCreateTable = async (date) =>{
        try{
            if(SRCreateStops.current !== null)
            {
                SRCreateStops.current.className = "d-none";
            }
            SRrowClickCreateGridCheck.current = "";
            let SRData = {
                "dtReqDate": date === '' ? selectedDateCreate:date,
                "vAffIDs": props.selectedAffiliates//props.selectedAffiliates
            };
            xCancelSourceForGrid.current = APICom.GenerateSource();
            setShowLoader(true);
            let response = await APICom.fetchData("GenericManifestDotNetCoreURL","api/StandingRoute/GetRoutesForSR", "post", {}, SRData, xCancelSourceForGrid.current);
            if(response["data"] !== null && response["data"].length > 0)
            {
                setSRCreateTableData(response["data"]);
            }
            else
            {
                setSRCreateTableData([]);
            }
            setShowLoader(false);
            // console.log(response);
        }
        catch(err){console.log(err);}
    }
    
    const handleStandingRoutesOpen = () => {
        console.log("reload");
    };
    const handleRefreshClick = () =>{
        initializeSRCreateTable('');
    };

    const handleCheckMandVehicle = () =>{
        setMandVehCheck(!mandVehCheck);
    };
    // Create/Update SR API handle
    const handleSaveUpdateStandingRoutes = async (e) =>{
        try{

            let createTableSelectedData = createSRMainTableObject.current.getSelectedRows()[0].getData();
            let createTableStopsData = createRouteStopsObject.current.getSelectedRows();
            let refIDs = "";
            let phrase = e.target.textContent;
            for(var k = 0; k < createTableStopsData.length; k++)
            {
                if(k !== (createTableStopsData.length-1))
                {
                    refIDs += createTableStopsData[k].getData()["Confirmation#"] + ",";
                }
                else
                {
                    refIDs += createTableStopsData[k].getData()["Confirmation#"];
                }
            }
            // console.log(createTableSelectedData);
            let vDays = ((CreateDaysSelected.Mon ? "1":"0")+(CreateDaysSelected.Tue ? "1":"0")+
            (CreateDaysSelected.Wed ? "1":"0")+(CreateDaysSelected.Thu ? "1":"0")+
            (CreateDaysSelected.Fri ? "1":"0")+(CreateDaysSelected.Sat ? "1":"0")+(CreateDaysSelected.Sun ? "1":"0"));
            if(updateCreateInfo.Name === "")
            {
                let UpdateRouteFooterBtns = ["OK"];
                let UpdateRouteFooterHTML = UpdateRouteFooterBtns.map(function(item, index){
                    return(
                        <Button key={index} value={item} className="activate_btn_ok mx-2 border-0" onClick={handleModalClose}>
                            {item}
                        </Button>
                    );
                });
                setModalHeaderText(phrase + " Alert");
                setModalBodyHTML("Please enter a name for SR!");
                setModalBtnHTML(UpdateRouteFooterHTML);
                setShowModal(true);
                setShowLoader(false);
            }
            else
            {   
                if(phrase === "Update")
                {
                    let updateRouteFooterBtns = ["Yes", "No"];
                    let updateRouteBody = [createTableSelectedData["SR Name"]];
                    let updateRouteFooterHTML = updateRouteFooterBtns.map(function(item, index){
                        return(
                            <Button key={index} value={item} className="activate_btn_ok mx-2 border-0" onClick={item === "Yes"?handleUpdateStandingRoutesSecondary:handleModalClose}>
                                {item}
                            </Button>
                        );
                    });
                    let updateBodyHTML = updateRouteBody.map(function(item,index){
                        return(
                            <Col key={index}>
                                <p>{"By performing update, all previously saved locked routes with SR Name"} <b className="fw-bolder">{"['"+item+"']"} </b>{"will be replaced " 
                                +"with current selected trips."}<br/>{"Do you want to Continue?"}</p>
                            </Col>
                        );
                    });
                    setModalHeaderText(phrase + " Confirmation");
                    setModalBodyHTML(updateBodyHTML);
                    setModalBtnHTML(updateRouteFooterHTML);
                    setShowModal(true);
                }
                else
                {
                    let SRData = {
                        "fileName": updateCreateInfo.Name,
                        "vDays": vDays,
                        "bAutoDownload": updateCreateInfo.Auto,
                        "dtAutoDownloadFrom":(updateCreateInfo.From === "" || updateCreateInfo.From === null? "01/01/1900":updateCreateInfo.From),
                        "dtAutoDownloadTo": (updateCreateInfo.To === "" || updateCreateInfo.To === null? "01/01/1900":updateCreateInfo.To),
                        "iRouteSummaryID": SRrowClickCreateGridCheck.current.ID,
                        "iStandingRouteID": (SRrowClickCreateGridCheck.current.iStandingRouteID? parseInt(SRrowClickCreateGridCheck.current.iStandingRouteID): 0),
                        "vSettingName": SRrowClickCreateGridCheck.current.vSettingName,
                        "vSRType": String(updateCreateInfo.SRType),
                        "vRefIDs": refIDs,
                        "bInsertMissingTrips": (updateCreateInfo.InsertMissing?1:0),
                        "iAffiliateID": parseInt(props.selectedAffiliates),//parseInt(props.selectedAffiliates),
                        "iUserID": parseInt(loginData.iUserID),
                        "vehNo": updateCreateInfo.vehicle,
                        "vRouteNo": updateCreateInfo.route
                    };
                    // console.log(SRrowClickCreateGridCheck.current);
                    xCancelSourceForGrid.current = APICom.GenerateSource();
                    setShowLoader(true);
                    let response = await APICom.fetchData("GenericManifestDotNetCoreURL","api/StandingRoute/SaveUpdateStandingRoutes", "post", {}, SRData, xCancelSourceForGrid.current);
                    // console.log(response);
                    if(response["data"] !== "")
                    {
                        if((response.data.Result === "Success" || parseInt(response.data.Result) === 1))
                        {
                            let createRouteFooterBtns = ["OK"];
                            let createRouteFooterHTML = createRouteFooterBtns.map(function(item, index){
                                return(
                                    <Button key={index} value={item} className="activate_btn_ok mx-2 border-0" onClick={handleModalClose}>
                                        {item}
                                    </Button>
                                );
                            });
                            setModalHeaderText(phrase + " Successful!");
                            setModalBodyHTML(response.data.Message);
                            setModalBtnHTML(createRouteFooterHTML);
                            setShowSaveModal(false);
                            setShowModal(true);
                            setShowLoader(false);
                            initializeSRCreateTable('');
                        }
                        else if((response.data.Result === "Fail" || parseInt(response.data.Result) === 0))
                        {
                            let updateRouteFooterBtns = ["OK"];
                            let updateRouteFooterHTML = updateRouteFooterBtns.map(function(item, index){
                                return(
                                    <Button key={index} value={item} className="activate_btn_ok mx-2 border-0" onClick={handleModalClose}>
                                        {item}
                                    </Button>
                                );
                            });
                            // let downloadBodyHTML = function(index){
                            //     return(
                            //         <Row key={index}>
                            //             <Col dangerouslySetInnerHTML={{__html:response.data[0].ErrorMsg}}>
        
                            //             </Col>
                            //         </Row>
                            //     );
                            // };
                            setModalHeaderText(phrase + " Failed!");
                            setModalBodyHTML(response.data.DetailMessage);
                            setModalBtnHTML(updateRouteFooterHTML);
                            setShowSaveModal(false);
                            setShowModal(true);
                            setShowLoader(false);
                        }
                       
                    }
                    else
                    {
                        let updateRouteFooterBtns = ["OK"];
                        let updateRouteFooterHTML = updateRouteFooterBtns.map(function(item, index){
                            return(
                                <Button key={index} value={item} className="activate_btn_ok mx-2 border-0" onClick={handleModalClose}>
                                    {item}
                                </Button>
                            );
                        });
                        setModalHeaderText(phrase + " Failed!");
                        setModalBodyHTML(response.error);
                        setModalBtnHTML(updateRouteFooterHTML);
                        setShowSaveModal(false);
                        setShowModal(true);
                        setShowLoader(false);
                    }
                }

                
            }
            
        }
        catch(err){console.log(err);}
    };

    const handleUpdateStandingRoutesSecondary = async (e)=>{
        try{
            setShowModal(false);
            let createTableSelectedData = createSRMainTableObject.current.getSelectedRows()[0].getData();
            let createTableStopsData = createRouteStopsObject.current.getSelectedRows();
            let refIDs = "";
            let phrase = e.target.textContent;
            for(var k = 0; k < createTableStopsData.length; k++)
            {
                if(k !== (createTableStopsData.length-1))
                {
                    refIDs += createTableStopsData[k].getData()["Confirmation#"] + ",";
                }
                else
                {
                    refIDs += createTableStopsData[k].getData()["Confirmation#"];
                }
            }
            // console.log(createTableSelectedData);
            let vDays = ((CreateDaysSelected.Mon ? "1":"0")+(CreateDaysSelected.Tue ? "1":"0")+
            (CreateDaysSelected.Wed ? "1":"0")+(CreateDaysSelected.Thu ? "1":"0")+
            (CreateDaysSelected.Fri ? "1":"0")+(CreateDaysSelected.Sat ? "1":"0")+(CreateDaysSelected.Sun ? "1":"0"));
            let SRData = {
                "fileName": updateCreateInfo.Name,
                "vDays": vDays,
                "bAutoDownload": updateCreateInfo.Auto,
                "dtAutoDownloadFrom":(updateCreateInfo.From === "" || updateCreateInfo.From === null? "01/01/1900":updateCreateInfo.From),
                "dtAutoDownloadTo": (updateCreateInfo.To === "" || updateCreateInfo.To === null? "01/01/1900":updateCreateInfo.To),
                "iRouteSummaryID": SRrowClickCreateGridCheck.current.ID,
                "iStandingRouteID": (SRrowClickCreateGridCheck.current.iStandingRouteID? parseInt(SRrowClickCreateGridCheck.current.iStandingRouteID): 0),
                "vSettingName": SRrowClickCreateGridCheck.current.vSettingName,
                "vSRType": String(updateCreateInfo.SRType),
                "vRefIDs": refIDs,
                "bInsertMissingTrips": (updateCreateInfo.InsertMissing?1:0),
                "iAffiliateID": parseInt(props.selectedAffiliates),//parseInt(props.selectedAffiliates),
                "iUserID": parseInt(loginData.iUserID),
                "vehNo": updateCreateInfo.vehicle,
                "vRouteNo": updateCreateInfo.route
            };
            // console.log(SRrowClickCreateGridCheck.current);
            xCancelSourceForGrid.current = APICom.GenerateSource();
            setShowLoader(true);
            let response = await APICom.fetchData("GenericManifestDotNetCoreURL","api/StandingRoute/SaveUpdateStandingRoutes", "post", {}, SRData, xCancelSourceForGrid.current);
            // console.log(response);
            if(response["data"] !== "")
            {
                if((response.data.Result === "Success" || parseInt(response.data.Result) === 1))
                {
                    let createRouteFooterBtns = ["OK"];
                    let createRouteFooterHTML = createRouteFooterBtns.map(function(item, index){
                        return(
                            <Button key={index} value={item} className="activate_btn_ok mx-2 border-0" onClick={handleModalClose}>
                                {item}
                            </Button>
                        );
                    });
                    setModalHeaderText(phrase + " Successful!");
                    setModalBodyHTML(response.data.Message);
                    setModalBtnHTML(createRouteFooterHTML);
                    setShowSaveModal(false);
                    setShowModal(true);
                    setShowLoader(false);
                    initializeSRCreateTable('');
                }
                else if((response.data.Result === "Fail" || parseInt(response.data.Result) === 0))
                {
                    let updateRouteFooterBtns = ["OK"];
                    let updateRouteFooterHTML = updateRouteFooterBtns.map(function(item, index){
                        return(
                            <Button key={index} value={item} className="activate_btn_ok mx-2 border-0" onClick={handleModalClose}>
                                {item}
                            </Button>
                        );
                    });
                    // let downloadBodyHTML = function(index){
                    //     return(
                    //         <Row key={index}>
                    //             <Col dangerouslySetInnerHTML={{__html:response.data[0].ErrorMsg}}>

                    //             </Col>
                    //         </Row>
                    //     );
                    // };
                    setModalHeaderText(phrase + " Failed!");
                    setModalBodyHTML(response.data.DetailMessage);
                    setModalBtnHTML(updateRouteFooterHTML);
                    setShowSaveModal(false);
                    setShowModal(true);
                    setShowLoader(false);
                }
            }
            else
            {
                let updateRouteFooterBtns = ["OK"];
                let updateRouteFooterHTML = updateRouteFooterBtns.map(function(item, index){
                    return(
                        <Button key={index} value={item} className="activate_btn_ok mx-2 border-0" onClick={handleModalClose}>
                            {item}
                        </Button>
                    );
                });
                setModalHeaderText(phrase + " Failed!");
                setModalBodyHTML(response.error);
                setModalBtnHTML(updateRouteFooterHTML);
                setShowSaveModal(false);
                setShowModal(true);
                setShowLoader(false);
            }
        
        }
        catch(err){console.log(err);}
    };

    const handleDateChange = (e) => {
        setSelectedDate(e.target.value);
        initializeSRTable(e.target.value);
    };
    
    const handleDateChangeCreate = (e) =>{
        setSelectedDateCreate(e.target.value);
        initializeSRCreateTable(e.target.value);
    }

    const handleDateChangeManage = (e) =>{
        setSelectedDateManage(e.target.value);
        initializeSRTableManage(e.target.value);
    }
    // Download SR API handle
    const handleDownloadRouteOperation = async(e) =>{
        try{

            let mainData = downloadSRMainTableObject.current.getSelectedRows()[0].getData();
            let stopsData = downloadSRStopsTableObject.current.getSelectedRows();
            let stopsDataLockIDs = "";
            for(var k = 0; k < stopsData.length; k++)
            {
                if(k !== (stopsData.length-1))
                {
                    stopsDataLockIDs += stopsData[k].getData().TripNo + ",";
                }
                else
                {
                    stopsDataLockIDs += stopsData[k].getData().TripNo;
                }
            }
            let SRData = {
                "iManifestNumber": mainData.iManifestNumber,
                "selectedDate": selectedDate,
                "iLockedIDs": stopsDataLockIDs,
                "chkMandatoryVehicle": mandVehCheck,
                "iUserID": parseInt(loginData.iUserID),
                "iSettingID": parseInt(mainData.iSettingID),
                "affiliateID": parseInt(mainData.iATSPID),
                "insertMissingMaster": downloadRouteRadioChecked,
                "vSettingName": mainData.vSettingName,
                "vSRType": String(mainData.iRouteEntityTypeID)
            };
            
            xCancelSourceForGrid.current = APICom.GenerateSource();
            setShowLoader(true);
            let response = await APICom.fetchData("GenericManifestDotNetCoreURL","api/StandingRoute/SaveExpandingRoute", "post", {}, SRData, xCancelSourceForGrid.current);
            if(response.data.length > 0)
            {
                if(response.data[0].Result === "Success" && response.data[0].ErrorMsg.length === 0)
                {
                    let downloadRouteFooterBtns = ["OK"];
                    let downloadRouteFooterHTML = downloadRouteFooterBtns.map(function(item, index){
                        return(
                            <Button key={index} value={item} className="activate_btn_ok mx-2 border-0" onClick={handleModalClose}>
                                {item}
                            </Button>
                        );
                    });
                    setModalHeaderText("Download Successful!");
                    setModalBodyHTML("Trip(s) have been expanded successfully!");
                    setModalBtnHTML(downloadRouteFooterHTML);
                    setShowDownloadDialogue(false);
                    setShowModal(true);
                    setShowLoader(false);
                    initializeSRTable('');
                }
                else if(response.data[0].Result === "Fail" || response.data[0].ErrorMsg.length > 0)
                {
                    let downloadRouteFooterBtns = ["OK"];
                    let downloadRouteFooterHTML = downloadRouteFooterBtns.map(function(item, index){
                        return(
                            <Button key={index} value={item} className="activate_btn_ok mx-2 border-0" onClick={handleModalClose}>
                                {item}
                            </Button>
                        );
                    });
                    let downloadBodyHTML = function(index){
                        return(
                            <Row key={index}>
                                <Col dangerouslySetInnerHTML={{__html:response.data[0].ErrorMsg}}>

                                </Col>
                            </Row>
                        );
                    };
                    setModalHeaderText("Download Warning");
                    setModalBodyHTML(downloadBodyHTML);
                    setModalBtnHTML(downloadRouteFooterHTML);
                    setShowDownloadDialogue(false);
                    setShowModal(true);
                    setShowLoader(false);
                }
                else
                {
                    let downloadRouteFooterBtns = ["OK"];
                    let downloadRouteFooterHTML = downloadRouteFooterBtns.map(function(item, index){
                        return(
                            <Button key={index} value={item} className="activate_btn_ok mx-2 border-0" onClick={handleModalClose}>
                                {item}
                            </Button>
                        );
                    });
                    let downloadBodyHTML = function(index){
                        return(
                            <Row key={index}>
                                <Col dangerouslySetInnerHTML={{__html:response.data[0].ErrorMsg}}>

                                </Col>
                            </Row>
                        );
                    };
                    setModalHeaderText("Download Failed!");
                    setModalBodyHTML(downloadBodyHTML);
                    setModalBtnHTML(downloadRouteFooterHTML);
                    setShowDownloadDialogue(false);
                    setShowModal(true);
                    setShowLoader(false);
                }
                
            }
            
        }
        catch(err){console.log(err);}
    }

    const handleSaveUpdateModalOpen = (e)=>{
        try{
            let phrase = e.target.textContent;
            if(createSRMainTableObject.current && createSRMainTableObject.current.getSelectedRows().length > 0)
            {
                let createStops = createRouteStopsObject.current.getSelectedRows();
                if(createStops.length === 0)
                {
                    let downloadRouteFooterBtns = ["OK"];
                    let downloadRouteFooterHTML = downloadRouteFooterBtns.map(function(item, index){
                        return(
                            <Button key={index} value={item} className="activate_btn_ok mx-2 border-0" onClick={handleModalClose}>
                                {item}
                            </Button>
                        );
                    });
                    setModalHeaderText(phrase+" Alert");
                    setModalBodyHTML("Please select a trip from the second table.");
                    setModalBtnHTML(downloadRouteFooterHTML);
                    setShowModal(true);
                }
                else
                {
                    
                    let createTableSelectedData = createSRMainTableObject.current.getSelectedRows()[0].getData();
                    let vehData = DispatchVehicleData[createTableSelectedData.ATSPID]; //tableSelectionData.iATSPID
                    if(vehData){


                        let array = JSON.parse(vehData);
                        const newObject = {"VehicleNumber": "-1", "VehicleID": -1, "VehicleType": "Cutaway16", "DriverNumber": "", "DriverID": -1, "DriverName": ",", "RowNumber": 46, "iAffID": 28, "STATE": "", "iVTypeID": 3, "VehicleNoANDRank": "-1", "MaxWheelChairs": 2, "TotalCapacity": 16, "LessPerWheelChair": 0.00};
                    
                        array.unshift(newObject);
                        
                        const updatedJSON = JSON.stringify(array);
                        let vehicleOptionsHTML = JSON.parse(updatedJSON).map(function(item, index){
                            return(
                                <option key={index} value={item.VehicleNumber}>{item.VehicleNumber}</option>
                            );
                        });
                        
                        setVehOptionsManageHTML(vehicleOptionsHTML);

                    }
                    
                    // console.log(createTableSelectedData);
                    let fromDateFormat = createTableSelectedData["Auto Downloaded From"] !== ""? (createTableSelectedData["Auto Downloaded From"].split("/")[2]+"-"+createTableSelectedData["Auto Downloaded From"].split("/")[0]+"-"+createTableSelectedData["Auto Downloaded From"].split("/")[1]):"";
                    let toDateFormat = createTableSelectedData["Auto Downloaded To"] !== ""? (createTableSelectedData["Auto Downloaded To"].split("/")[2]+"-"+createTableSelectedData["Auto Downloaded To"].split("/")[0]+"-"+createTableSelectedData["Auto Downloaded To"].split("/")[1]):"";
                    setUpdateCreateInfo({Name:(createTableSelectedData["SR Name"]?createTableSelectedData["SR Name"]:""), From:fromDateFormat, To:toDateFormat, 
                        Auto:(createTableSelectedData["Auto Download"] ? createTableSelectedData["Auto Download"]:true), InsertMissing:createTableSelectedData.InsertMissingTrips, SRType: (createTableSelectedData.iRouteEntityTypeID === null || createTableSelectedData.iRouteEntityTypeID === -1? "2":createTableSelectedData.iRouteEntityTypeID),
                        route:createTableSelectedData["Route#"], vehicle:createTableSelectedData["Veh#"]});
                    setSaveModalTitle(phrase+" Standing Route");
                    setCreateDaysSelected({Mon:((createTableSelectedData.Mon).toLowerCase()==="false"?0:1),Tue:((createTableSelectedData.Tue).toLowerCase()==="false"?0:1),Wed:((createTableSelectedData.Wed).toLowerCase()==="false"?0:1),
                        Thu:((createTableSelectedData.Thu).toLowerCase()==="false"?0:1),Fri:((createTableSelectedData.Fri).toLowerCase()==="false"?0:1),Sat:((createTableSelectedData.Sat).toLowerCase()==="false"?0:1),
                        Sun:((createTableSelectedData.Sun).toLowerCase()==="false"?0:1)});
                    setShowSaveModal(true); 
                }
            }
            else
            {
                let downloadRouteFooterBtns = ["OK"];
                let downloadRouteFooterHTML = downloadRouteFooterBtns.map(function(item, index){
                    return(
                        <Button key={index} value={item} className="activate_btn_ok mx-2 border-0" onClick={handleModalClose}>
                            {item}
                        </Button>
                    );
                });
                setModalHeaderText(phrase+" Alert");
                setModalBodyHTML("Please select a route from the dispatch table.");
                setModalBtnHTML(downloadRouteFooterHTML);
                setShowModal(true);
            }

        }
        catch(err){console.log(err);}
        
    }
    // Update SR API handle
    const handleUpdateSRSetting = async () =>{
        try{
            if(updateSRInfo.Name === "")
            {
                let UpdateRouteFooterBtns = ["OK"];
                let UpdateRouteFooterHTML = UpdateRouteFooterBtns.map(function(item, index){
                    return(
                        <Button key={index} value={item} className="activate_btn_ok mx-2 border-0" onClick={handleModalClose}>
                            {item}
                        </Button>
                    );
                });
                setModalHeaderText(manageBtnNames[0]+" Alert");
                setModalBodyHTML("Please enter a name for SR!");
                setModalBtnHTML(UpdateRouteFooterHTML);
                setShowModal(true);
            }
            else
            {
                let vDays = (manageDaysSelected.Mon? "1":"0")+(manageDaysSelected.Tue? "1":"0")+
                (manageDaysSelected.Wed? "1":"0")+(manageDaysSelected.Thu? "1":"0")+
                (manageDaysSelected.Fri? "1":"0")+(manageDaysSelected.Sat? "1":"0")+
                (manageDaysSelected.Sun? "1":"0");
                let manageMainData = manageSRMainTableObject.current.getSelectedRows()[0].getData();
                let SRData = {
                    "dtAutoDownloadFrom": (updateSRInfo.From === "" || updateSRInfo.From === null ? "01/01/1900":updateSRInfo.From),
                    "dtAutoDownloadTo": (updateSRInfo.To === "" || updateSRInfo.To === null ? "01/01/1900":updateSRInfo.To),
                    "bAutoDownload": updateSRInfo.Auto,
                    "iManifestNumber": manageMainData.iManifestNumber,
                    "selectedDays": vDays,
                    "vehNo": updateSRInfo.Veh,
                    "routeNo": updateSRInfo.RouteNo,
                    "srName": updateSRInfo.Name,
                    "iAffiliateID": manageMainData.iATSPID,
                    "insert_missing_trips": (updateSRInfo.InsertMissing?1:0),
                    "vSRType": String(updateSRInfo.SRType)
                };
                
                xCancelSourceForGrid.current = APICom.GenerateSource();
                setShowLoader(true);
                let response = await APICom.fetchData("GenericManifestDotNetCoreURL","api/StandingRoute/UpdateStandingRoute", "post", {}, SRData, xCancelSourceForGrid.current);
                if(response.data.length > 0)
                {
                    if(response.data[0].Result === "Success" && response.data[0].ErrorMsg.length === 0)
                    {
                        let manageRouteFooterBtns = ["OK"];
                        let manageRouteFooterHTML = manageRouteFooterBtns.map(function(item, index){
                            return(
                                <Button key={index} value={item} className="activate_btn_ok mx-2 border-0" onClick={handleModalClose}>
                                    {item}
                                </Button>
                            );
                        });
                        
                        setModalHeaderText(manageBtnNames[0]+" Successful!");
                        setModalBodyHTML("SR Updated Successfully.");
                        setShowUpdateSRSettingsModal(false);
                        setModalBtnHTML(manageRouteFooterHTML);
                        setShowModal(true);
                        setShowLoader(false);
                        initializeSRTableManage('');
                    }
                    else if(response.data[0].Result === "Fail" && response.data[0].ErrorMsg.length > 0)
                    {
                        let manageRouteFooterBtns = ["OK"];
                        let manageRouteFooterHTML = manageRouteFooterBtns.map(function(item, index){
                            return(
                                <Button key={index} value={item} className="activate_btn_ok mx-2 border-0" onClick={handleModalClose}>
                                    {item}
                                </Button>
                            );
                        });
                        let manageBodyHTML = function(index){
                            return(
                                <Row key={index}>
                                    <Col dangerouslySetInnerHTML={{__html:response.data[0].ErrorMsg}}>

                                    </Col>
                                </Row>
                            );
                        };
                        setModalHeaderText(manageBtnNames[0]+" Failed!");
                        setModalBodyHTML(manageBodyHTML);
                        setModalBtnHTML(manageRouteFooterHTML);
                        setShowUpdateSRSettingsModal(false);
                        setShowModal(true);
                        setShowLoader(false);
                    }
                    else
                    {
                        let manageRouteFooterBtns = ["OK"];
                        let manageRouteFooterHTML = manageRouteFooterBtns.map(function(item, index){
                            return(
                                <Button key={index} value={item} className="activate_btn_ok mx-2 border-0" onClick={handleModalClose}>
                                    {item}
                                </Button>
                            );
                        });
                        let manageBodyHTML = function(index){
                            return(
                                <Row key={index}>
                                    <Col dangerouslySetInnerHTML={{__html:response.data[0].ErrorMsg}}>

                                    </Col>
                                </Row>
                            );
                        };
                        setModalHeaderText(manageBtnNames[0]+" Failed!");
                        setModalBodyHTML(manageBodyHTML);
                        setModalBtnHTML(manageRouteFooterHTML);
                        setShowUpdateSRSettingsModal(false);
                        setShowModal(true);
                        setShowLoader(false);
                    }
                   
                }
                else
                {
                    let UpdateRouteFooterBtns = ["OK"];
                    let UpdateRouteFooterHTML = UpdateRouteFooterBtns.map(function(item, index){
                        return(
                            <Button key={index} value={item} className="activate_btn_ok mx-2 border-0" onClick={handleModalClose}>
                                {item}
                            </Button>
                        );
                    });
                    setModalHeaderText(manageBtnNames[0]+ " Failed");
                    setModalBodyHTML(response.error);
                    setModalBtnHTML(UpdateRouteFooterHTML);
                    setShowUpdateSRSettingsModal(false);
                    setShowModal(true);
                    setShowLoader(false);
                }
            }
            
        }
        catch(err){console.log(err);}
        
    }

    const handleDownloadRadioCheck = (e) =>{
        
        setDownloadRouteRadioChecked(parseInt(e.target.value));
    }
    const handleDayChangeofManage = (day, bChecked)=>{
        setManageDaysSelected({...manageDaysSelected, [day]: bChecked});
    }
    const handleDayChangeofCreate = (day, bChecked)=>{
        setCreateDaysSelected({...CreateDaysSelected, [day]: bChecked});
    }

    const handleDayChangeTripPrescheduleManage = (day, bChecked)=>{
        setManageTripDaysSelected({...manageTripDaysSelected, [day]:(bChecked+","+day.split('')[0])});
    }

    const handleDownloadRouteOpen = (e) =>{
        let currentData = downloadSRMainTableObject.current.getSelectedRows();
        
        if(currentData.length === 0)
        {
            setShowDownloadDialogue(false);
            let downloadRouteFooterBtns = ["OK"];
            let downloadRouteFooterHTML = downloadRouteFooterBtns.map(function(item, index){
                return(
                    <Button key={index} value={item} className="activate_btn_ok mx-2 border-0" onClick={handleModalClose}>
                        {item}
                    </Button>
                );
            });
            setModalHeaderText(downloadBtnNames[0]);
            setModalBodyHTML("Please select a SR from the first table.");
            setModalBtnHTML(downloadRouteFooterHTML);
            setShowModal(true);
        }
        else
        {
            if(downloadSRStopsTableObject.current.getSelectedRows().length === 0)
            {
                setShowDownloadDialogue(false);
                let downloadRouteFooterBtns = ["OK"];
                let downloadRouteFooterHTML = downloadRouteFooterBtns.map(function(item, index){
                    return(
                        <Button key={index} value={item} className="activate_btn_ok mx-2 border-0" onClick={handleModalClose}>
                            {item}
                        </Button>
                    );
                });
                setModalHeaderText("Download Alert");
                setModalBodyHTML("Please select a trip from the second table.");
                setModalBtnHTML(downloadRouteFooterHTML);
                setShowModal(true);
            }
            else
            {
                let currentDataParsed = currentData[0].getData();
                // let downloadRouteBodyBtns = ["Insert Missing Trips", "Do Not Insert Missing Trips", "Mandatory Vehicle"];
                // let downloadRouteFooterBtns = ["Download", "Cancel"];
                setShowDownloadDialogue(true);
                if(currentDataParsed.InsertMissingTrips)
                {
                    setDownloadRouteRadioChecked(1);
                }
                else
                {
                    setDownloadRouteRadioChecked(2);
                }
                
            }
            
        }
        
    }
    
    const handleUpdateSettingModalOpen = ()=>{
        try{
            let tableSelection = manageSRMainTableObject.current.getSelectedRows();
            let manageRouteFooterBtns = ["OK"];
            let manageRouteFooterHTML = manageRouteFooterBtns.map(function(item, index){
                return(
                    <Button key={index} value={item} className="activate_btn_ok mx-2 border-0" onClick={handleModalClose}>
                        {item}
                    </Button>
                );
            });
            if(tableSelection.length === 0)
            {
                setModalHeaderText("Update SR Alert");
                setModalBodyHTML("Please select a route.");
                setModalBtnHTML(manageRouteFooterHTML);
                setShowModal(true);
            }
            else
            {
                if(showUpdateSRSettingsModal === false)
                {
                    let tableSelectionData = tableSelection[0].getData();
                    let vehData = DispatchVehicleData[tableSelectionData.iATSPID]; //tableSelectionData.iATSPID
                    // console.log(vehData);
                    let array = JSON.parse(vehData);
                    const newObject = {"VehicleNumber": '-1', "VehicleID": -1, "VehicleType": "Cutaway16", "DriverNumber": "", "DriverID": -1, "DriverName": ",", "RowNumber": 46, "iAffID": 28, "STATE": "", "iVTypeID": 3, "VehicleNoANDRank": "-1", "MaxWheelChairs": 2, "TotalCapacity": 16, "LessPerWheelChair": 0.00};
                
                    array.unshift(newObject);
                    
                    const updatedJSON = JSON.stringify(array);
                    let vehicleOptionsHTML = JSON.parse(updatedJSON).map(function(item, index){
                        return(
                            <option key={index} value={item.VehicleNumber}>{item.VehicleNumber}</option>
                        );
                    });
                    setVehOptionsManageHTML(vehicleOptionsHTML);
                    // console.log(tableSelectionData);
                    let fromDateFormat = tableSelectionData.AutoDownloadFrom !== ""? (tableSelectionData.AutoDownloadFrom.split("/")[2]+"-"+tableSelectionData.AutoDownloadFrom.split("/")[0]+"-"+tableSelectionData.AutoDownloadFrom.split("/")[1]):"";
                    let toDateFormat = tableSelectionData.AutoDownloadTo !== ""? (tableSelectionData.AutoDownloadTo.split("/")[2]+"-"+tableSelectionData.AutoDownloadTo.split("/")[0]+"-"+tableSelectionData.AutoDownloadTo.split("/")[1]):"";
                    setUpdateSRInfo({Name:tableSelectionData.Name,Veh:tableSelectionData["Veh#"],From:fromDateFormat,To:toDateFormat,Auto:tableSelectionData.bAutoDownloadService,InsertMissing:tableSelectionData.InsertMissingTrips,SRType:(tableSelectionData.iRouteEntityTypeID === -1?"2":tableSelectionData.iRouteEntityTypeID), RouteNo:tableSelectionData["Route#"]});
                    setManageDaysSelected({Mon:tableSelectionData.Mon,Tue:tableSelectionData.Tue,Wed:tableSelectionData.Wed,Thu:tableSelectionData.Thu,Fri:tableSelectionData.Fri,Sat:tableSelectionData.Sat,Sun:tableSelectionData.Sun});
                    // console.log(tableSelectionData);
                    setShowUpdateSRSettingsModal(true);
                }
                else
                {
                    setShowUpdateSRSettingsModal(false);
                }
            }
        }
        catch(err){console.log(err);}
        
        
    }
    // Remove trips/Route API handle
    const handleRemoveTripsOrRouteModalOpen = async ()=>{
        try{
            let mainManageTableData = manageSRMainTableObject.current.getSelectedRows();
            if(mainManageTableData.length === 0)
            {
                let RouteFooterBtns = ["OK"];
                let RouteFooterHTML = RouteFooterBtns.map(function(item, index){
                    return(
                        <Button key={index} value={item} className="activate_btn_ok mx-2 border-0" onClick={handleModalClose}>
                            {item}
                        </Button>
                    );
                });
                setModalHeaderText("Route/Trip(s) Removal Alert");
                setModalBodyHTML("Please select a SR from the first table.");
                setModalBtnHTML(RouteFooterHTML);
                setShowModal(true);
            }
            else
            {
                let manageTableStopsData = manageSRStopsTableObject.current.getSelectedRows();
                if(manageTableStopsData.length === 0)
                {
                    let RouteFooterBtns = ["OK"];
                    let RouteFooterHTML = RouteFooterBtns.map(function(item, index){
                        return(
                            <Button key={index} value={item} className="activate_btn_ok mx-2 border-0" onClick={handleModalClose}>
                                {item}
                            </Button>
                        );
                    });
                    setModalHeaderText("Route/Trip(s) Removal Alert");
                    setModalBodyHTML("Please select a Trip from the second table.");
                    setModalBtnHTML(RouteFooterHTML);
                    setShowModal(true);
                }
                else
                {
                    let stopsDataLockIDs = "";
                    for(var k = 0; k < manageTableStopsData.length; k++)
                    {
                        if(k !== (manageTableStopsData.length-1))
                        {
                            stopsDataLockIDs += manageTableStopsData[k].getData().TripNo + ",";
                        }
                        else
                        {
                            stopsDataLockIDs += manageTableStopsData[k].getData().TripNo;
                        }
                    }
                    let SRData = {
                        "lockedIDs": stopsDataLockIDs
                    };
                    
                    xCancelSourceForGrid.current = APICom.GenerateSource();
                    setShowLoader(true);
                    let response = await APICom.fetchData("GenericManifestDotNetCoreURL","api/StandingRoute/RemoveStandingRoute", "post", {}, SRData, xCancelSourceForGrid.current);
                    if(response.data.length > 0)
                    {
                        if(response.data[0].Result === "Success" && response.data[0].ErrorMsg.length === 0)
                        {
                            let manageRouteFooterBtns = ["OK"];
                            let manageRouteFooterHTML = manageRouteFooterBtns.map(function(item, index){
                                return(
                                    <Button key={index} value={item} className="activate_btn_ok mx-2 border-0" onClick={handleModalClose}>
                                        {item}
                                    </Button>
                                );
                            });
                            
                            setModalHeaderText("Route/Trip(s) Removal Successful!");
                            setModalBodyHTML((manageTableStopsData.length === 1? "Trip Removed Successfully.":"Trips Removed Successfully."));
                            setModalBtnHTML(manageRouteFooterHTML);
                            setShowModal(true);
                            setShowLoader(false);
                            initializeSRTableManage('');
                        }
                        else if(response.data[0].Result === "Fail" && response.data[0].ErrorMsg.length > 0)
                        {
                            let manageRouteFooterBtns = ["OK"];
                            let manageRouteFooterHTML = manageRouteFooterBtns.map(function(item, index){
                                return(
                                    <Button key={index} value={item} className="activate_btn_ok mx-2 border-0" onClick={handleModalClose}>
                                        {item}
                                    </Button>
                                );
                            });
                            let manageBodyHTML = function(index){
                                return(
                                    <Row key={index}>
                                        <Col dangerouslySetInnerHTML={{__html:response.data[0].ErrorMsg}}>

                                        </Col>
                                    </Row>
                                );
                            };
                            setModalHeaderText("Route/Trip(s) Removal Failed!");
                            setModalBodyHTML(manageBodyHTML);
                            setModalBtnHTML(manageRouteFooterHTML);
                            setShowModal(true);
                            setShowLoader(false);
                        }
                        else
                        {
                            let manageRouteFooterBtns = ["OK"];
                            let manageRouteFooterHTML = manageRouteFooterBtns.map(function(item, index){
                                return(
                                    <Button key={index} value={item} className="activate_btn_ok mx-2 border-0" onClick={handleModalClose}>
                                        {item}
                                    </Button>
                                );
                            });
                            let manageBodyHTML = function(index){
                                return(
                                    <Row key={index}>
                                        <Col dangerouslySetInnerHTML={{__html:response.data[0].ErrorMsg}}>

                                        </Col>
                                    </Row>
                                );
                            };
                            setModalHeaderText("Route/Trip(s) Removal Failed!");
                            setModalBodyHTML(manageBodyHTML);
                            setModalBtnHTML(manageRouteFooterHTML);
                            setShowModal(true);
                            setShowLoader(false);
                            
                        }
                        
                    }
                    else
                    {
                        let manageRouteFooterBtns = ["OK"];
                        let manageRouteFooterHTML = manageRouteFooterBtns.map(function(item, index){
                            return(
                                <Button key={index} value={item} className="activate_btn_ok mx-2 border-0" onClick={handleModalClose}>
                                    {item}
                                </Button>
                            );
                        });
                        setModalHeaderText("Route/Trip(s) Removal Failed");
                        setModalBodyHTML(response.error);
                        setModalBtnHTML(manageRouteFooterHTML);
                        setShowModal(true);
                        setShowLoader(false);
                    }
                    
                }
                
            }
             
        }
        catch(err){console.log(err);}
    }

    const handleUpdateTimeModalOpen = ()=>{
        try{
            let mainManageTableData = manageSRMainTableObject.current.getSelectedRows();
            if(mainManageTableData.length === 0)
            {
                let RouteFooterBtns = ["OK"];
                let RouteFooterHTML = RouteFooterBtns.map(function(item, index){
                    return(
                        <Button key={index} value={item} className="activate_btn_ok mx-2 border-0" onClick={handleModalClose}>
                            {item}
                        </Button>
                    );
                });
                setModalHeaderText("Update Time Alert");
                setModalBodyHTML("Please select a SR from the first table.");
                setModalBtnHTML(RouteFooterHTML);
                setShowModal(true);
            }
            else
            {
                let manageTableStopsData = manageSRStopsTableObject.current.getSelectedRows();
                if(manageTableStopsData.length === 0)
                {
                    let RouteFooterBtns = ["OK"];
                    let RouteFooterHTML = RouteFooterBtns.map(function(item, index){
                        return(
                            <Button key={index} value={item} className="activate_btn_ok mx-2 border-0" onClick={handleModalClose}>
                                {item}
                            </Button>
                        );
                    });
                    setModalHeaderText("Update Time Alert");
                    setModalBodyHTML("Please select a Trip from the second table.");
                    setModalBtnHTML(RouteFooterHTML);
                    setShowModal(true);
                }
                else
                {
                    if(manageTableStopsData.length > 1)
                    {
                        let RouteFooterBtns = ["OK"];
                        let RouteFooterHTML = RouteFooterBtns.map(function(item, index){
                            return(
                                <Button key={index} value={item} className="activate_btn_ok mx-2 border-0" onClick={handleModalClose}>
                                    {item}
                                </Button>
                            );
                        });
                        setModalHeaderText("Update Time Alert");
                        setModalBodyHTML("Please select a single Trip from the second table.");
                        setModalBtnHTML(RouteFooterHTML);
                        setShowModal(true);
                    }
                    else
                    {
                        let manageStopsData = manageTableStopsData[0].getData();
                        setUpdateTimeInfoManage({requestedTime:manageStopsData.ReqTime, SystemTime:manageStopsData["SysSch Time"]});
                        setShowUpdateTimeDialog(true);
                    }
                }
                
            }
        }
        catch(err){console.log(err);}
    }
    //preschedule trip API handle
    const handlePrescheduleUpdateOnManageTrip = async()=>{
        try{
            let manageTableStopsData = manageSRStopsTableObject.current.getSelectedRows()[0].getData();
            let manageTableMainData = manageSRMainTableObject.current.getSelectedRows()[0].getData();
            let vDays = manageTripDaysSelected.Mon.split(",")[1]+manageTripDaysSelected.Tue.split(",")[1]+
                manageTripDaysSelected.Wed.split(",")[1]+manageTripDaysSelected.Thu.split(",")[1]+
                manageTripDaysSelected.Fri.split(",")[1]+manageTripDaysSelected.Sat.split(",")[1]+
                manageTripDaysSelected.Sun.split(",")[1];
            let SRData = {
                "iLockedID": manageTableStopsData.TripNo,
                "preSchedule": vDays,
                "iAffiliateID": manageTableMainData.iATSPID
            };
            xCancelSourceForGrid.current = APICom.GenerateSource();

            setShowLoader(true);
            let response = await APICom.fetchData("GenericManifestDotNetCoreURL","api/StandingRoute/PreScheduleSRTrip", "post", {}, SRData, xCancelSourceForGrid.current);

            if(response.data.Result.length > 0 || response.data.ErrorMsg.length > 0)
            {
                if(response.data.Result === "Success" && response.data.ErrorMsg.length === 0)
                {
                    let manageRouteFooterBtns = ["OK"];
                    let manageRouteFooterHTML = manageRouteFooterBtns.map(function(item, index){
                        return(
                            <Button key={index} value={item} className="activate_btn_ok mx-2 border-0" onClick={handleModalClose}>
                                {item}
                            </Button>
                        );
                    });
                    setModalHeaderText(manageBtnNames[4]+ " Successful!");
                    setModalBodyHTML("Preset schedule for selected trip successfully updated.");
                    setModalBtnHTML(manageRouteFooterHTML);
                    setShowLoader(false);
                    setShowModal(true);
                    initializeSRStopsTableManage(manageTableMainData);
                }
                else if(response.data.Result === "Fail" && response.data.ErrorMsg.length > 0)
                {
                    let manageRouteFooterBtns = ["OK"];
                    let manageRouteFooterHTML = manageRouteFooterBtns.map(function(item, index){
                        return(
                            <Button key={index} value={item} className="activate_btn_ok mx-2 border-0" onClick={handleModalClose}>
                                {item}
                            </Button>
                        );
                    });
                    let manageBodyHTML = function(index){
                        return(
                            <Row key={index}>
                                <Col dangerouslySetInnerHTML={{__html:response.data.ErrorMsg}}>
    
                                </Col>
                            </Row>
                        );
                    };
                    setModalHeaderText(manageBtnNames[4]+" Failed!");
                    setModalBodyHTML(manageBodyHTML);
                    setModalBtnHTML(manageRouteFooterHTML);
                    setShowLoader(false);
                    setShowModal(true);
                }
                else
                {
                    let manageRouteFooterBtns = ["OK"];
                    let manageRouteFooterHTML = manageRouteFooterBtns.map(function(item, index){
                        return(
                            <Button key={index} value={item} className="activate_btn_ok mx-2 border-0" onClick={handleModalClose}>
                                {item}
                            </Button>
                        );
                    });
                    let manageBodyHTML = function(index){
                        return(
                            <Row key={index}>
                                <Col dangerouslySetInnerHTML={{__html:response.data.ErrorMsg}}>
    
                                </Col>
                            </Row>
                        );
                    };
                    setModalHeaderText(manageBtnNames[4]+" Failed!");
                    setModalBodyHTML(manageBodyHTML);
                    setModalBtnHTML(manageRouteFooterHTML);
                    setShowLoader(false);
                    setShowModal(true);
                }
            }
            else
            {
                let manageRouteFooterBtns = ["OK"];
                let manageRouteFooterHTML = manageRouteFooterBtns.map(function(item, index){
                    return(
                        <Button key={index} value={item} className="activate_btn_ok mx-2 border-0" onClick={handleModalClose}>
                            {item}
                        </Button>
                    );
                });
                setModalHeaderText(manageBtnNames[4]+ " Failed!");
                setModalBodyHTML(response.error);
                setModalBtnHTML(manageRouteFooterHTML);
                setShowLoader(false);
                setShowModal(true);
            }
        }
        catch(err){console.log(err);}
    };

    const handlePrescheduleModalOpen = ()=>{
        try{
            let mainManageTableData = manageSRMainTableObject.current.getSelectedRows();
            if(mainManageTableData.length === 0)
            {
                let RouteFooterBtns = ["OK"];
                let RouteFooterHTML = RouteFooterBtns.map(function(item, index){
                    return(
                        <Button key={index} value={item} className="activate_btn_ok mx-2 border-0" onClick={handleModalClose}>
                            {item}
                        </Button>
                    );
                });
                setModalHeaderText(manageBtnNames[4]+ " Alert");
                setModalBodyHTML("Please select a SR from the first table.");
                setModalBtnHTML(RouteFooterHTML);
                setShowModal(true);
            }
            else
            {
                let manageTableStopsData = manageSRStopsTableObject.current.getSelectedRows();
                if(manageTableStopsData.length === 0)
                {
                    let RouteFooterBtns = ["OK"];
                    let RouteFooterHTML = RouteFooterBtns.map(function(item, index){
                        return(
                            <Button key={index} value={item} className="activate_btn_ok mx-2 border-0" onClick={handleModalClose}>
                                {item}
                            </Button>
                        );
                    });
                    setModalHeaderText(manageBtnNames[4]+" Alert");
                    setModalBodyHTML("Please select a Trip from the second table.");
                    setModalBtnHTML(RouteFooterHTML);
                    setShowModal(true);
                }
                else
                {
                    if(manageTableStopsData.length > 1)
                    {
                        let RouteFooterBtns = ["OK"];
                        let RouteFooterHTML = RouteFooterBtns.map(function(item, index){
                            return(
                                <Button key={index} value={item} className="activate_btn_ok mx-2 border-0" onClick={handleModalClose}>
                                    {item}
                                </Button>
                            );
                        });
                        setModalHeaderText(manageBtnNames[4]+" Alert");
                        setModalBodyHTML("Please select a single Trip from the second table.");
                        setModalBtnHTML(RouteFooterHTML);
                        setShowModal(true);
                    }
                    else
                    {
                        let manageStopsData = manageTableStopsData[0].getData();
                        let manageMainData = mainManageTableData[0].getData();
                        let prescheduleMainDataFormatted = [(manageMainData.Mon?"M":' '),(manageMainData.Tue?"T":' '),(manageMainData.Wed?"W":' '),(manageMainData.Thu?"T":' '),(manageMainData.Fri?"F":' '),(manageMainData.Sat?"S":' '),(manageMainData.Sun?"S":' ')];
                        setDisabledDatesManageCheck({Mon:(manageMainData.Mon+","+prescheduleMainDataFormatted[0]),Tue:(manageMainData.Tue+","+prescheduleMainDataFormatted[1]),Wed:(manageMainData.Wed+","+prescheduleMainDataFormatted[2]),
                        Thu:(manageMainData.Thu+","+prescheduleMainDataFormatted[3]),Fri:(manageMainData.Fri+","+prescheduleMainDataFormatted[4]),Sat:(manageMainData.Sat+","+prescheduleMainDataFormatted[5]),Sun:(manageMainData.Sun+","+prescheduleMainDataFormatted[6])});
                        if(manageStopsData.PreSchedule === null || manageStopsData.PreSchedule === "")
                        {
                            setManageTripDaysSelected({Mon:(manageMainData.Mon+","+prescheduleMainDataFormatted[0]),Tue:(manageMainData.Tue+","+prescheduleMainDataFormatted[1]),Wed:(manageMainData.Wed+","+prescheduleMainDataFormatted[2]),
                                Thu:(manageMainData.Thu+","+prescheduleMainDataFormatted[3]),Fri:(manageMainData.Fri+","+prescheduleMainDataFormatted[4]),Sat:(manageMainData.Sat+","+prescheduleMainDataFormatted[5]),Sun:(manageMainData.Sun+","+prescheduleMainDataFormatted[6])});
                        }
                        else
                        {
                            let prescheduleDays = manageStopsData.PreSchedule.split('');
                            let manageTripPrescheduleList = [];
                            if(prescheduleDays[1] === "M" || prescheduleDays[2] === "T")
                            {
                                if(prescheduleDays[0] !== ' ')      //Sun Mon Tue Wed Thu Fri Sat
                                {
                                    manageTripPrescheduleList.push((true+",S"));
                                }
                                else manageTripPrescheduleList.push((false+', '));
                                if(prescheduleDays[1] !== ' ')
                                {
                                    manageTripPrescheduleList.push((true+",M"));
                                }
                                else manageTripPrescheduleList.push((false+", "));
                                if(prescheduleDays[2] !== ' ')
                                {
                                    manageTripPrescheduleList.push((true+",T"));
                                }
                                else manageTripPrescheduleList.push((false+", "));
                                if(prescheduleDays[3] !== ' ')
                                {
                                    manageTripPrescheduleList.push((true+",W"));
                                }
                                else manageTripPrescheduleList.push((false+", "));
                                if(prescheduleDays[4] !== ' ')
                                {
                                    manageTripPrescheduleList.push((true+",T"));
                                }
                                else manageTripPrescheduleList.push((false+", "));
                                if(prescheduleDays[5] !== ' ')
                                {
                                    manageTripPrescheduleList.push((true+",F"));
                                }
                                else manageTripPrescheduleList.push((false+", "));
                                if(prescheduleDays[6] !== ' ')
                                {
                                    manageTripPrescheduleList.push((true+",S"));
                                }
                                else manageTripPrescheduleList.push((false+", "));
                                setManageTripDaysSelected({Mon:manageTripPrescheduleList[1],Tue:manageTripPrescheduleList[2],Wed:manageTripPrescheduleList[3],
                                    Thu:manageTripPrescheduleList[4],Fri:manageTripPrescheduleList[5],Sat:manageTripPrescheduleList[6],Sun:manageTripPrescheduleList[0]});
                            }
                            else
                            {
                                if(prescheduleDays[0] !== ' ')      //Mon Tue Wed Thu Fri Sat Sun
                                {
                                    manageTripPrescheduleList.push((true+",M"));
                                }
                                else manageTripPrescheduleList.push((false+', '));
                                if(prescheduleDays[1] !== ' ')
                                {
                                    manageTripPrescheduleList.push((true+",T"));
                                }
                                else manageTripPrescheduleList.push((false+", "));
                                if(prescheduleDays[2] !== ' ')
                                {
                                    manageTripPrescheduleList.push((true+",W"));
                                }
                                else manageTripPrescheduleList.push((false+", "));
                                if(prescheduleDays[3] !== ' ')
                                {
                                    manageTripPrescheduleList.push((true+",T"));
                                }
                                else manageTripPrescheduleList.push((false+", "));
                                if(prescheduleDays[4] !== ' ')
                                {
                                    manageTripPrescheduleList.push((true+",F"));
                                }
                                else manageTripPrescheduleList.push((false+", "));
                                if(prescheduleDays[5] !== ' ')
                                {
                                    manageTripPrescheduleList.push((true+",S"));
                                }
                                else manageTripPrescheduleList.push((false+", "));
                                if(prescheduleDays[6] !== ' ')
                                {
                                    manageTripPrescheduleList.push((true+",S"));
                                }
                                else manageTripPrescheduleList.push((false+", "));
                                setManageTripDaysSelected({Mon:manageTripPrescheduleList[0],Tue:manageTripPrescheduleList[1],Wed:manageTripPrescheduleList[2],
                                    Thu:manageTripPrescheduleList[3],Fri:manageTripPrescheduleList[4],Sat:manageTripPrescheduleList[5],Sun:manageTripPrescheduleList[6]});
                            }
                            
                            // console.log(manageStopsData.PreSchedule, prescheduleDays, manageTripPrescheduleList);
                            
                        }
                        setShowPreScheduleModal(true);
                    }
                }
                
            }
        }
        catch(err){console.log(err);}
    };

    const handleEditTripModalOpen = async()=>{
        try{
            let mainManageTableData = manageSRMainTableObject.current.getSelectedRows();
            if(mainManageTableData.length === 0)
            {
                let RouteFooterBtns = ["OK"];
                let RouteFooterHTML = RouteFooterBtns.map(function(item, index){
                    return(
                        <Button key={index} value={item} className="activate_btn_ok mx-2 border-0" onClick={handleModalClose}>
                            {item}
                        </Button>
                    );
                });
                setModalHeaderText(manageBtnNames[3]+ " Alert");
                setModalBodyHTML("Please select a SR from the first table.");
                setModalBtnHTML(RouteFooterHTML);
                setShowModal(true);
            }
            else
            {
                let manageTableStopsData = manageSRStopsTableObject.current.getSelectedRows();
                if(manageTableStopsData.length === 0)
                {
                    let RouteFooterBtns = ["OK"];
                    let RouteFooterHTML = RouteFooterBtns.map(function(item, index){
                        return(
                            <Button key={index} value={item} className="activate_btn_ok mx-2 border-0" onClick={handleModalClose}>
                                {item}
                            </Button>
                        );
                    });
                    setModalHeaderText(manageBtnNames[3]+" Alert");
                    setModalBodyHTML("Please select a Trip from the second table.");
                    setModalBtnHTML(RouteFooterHTML);
                    setShowModal(true);
                }
                else if(manageTableStopsData.length > 1)
                {
                    let RouteFooterBtns = ["OK"];
                    let RouteFooterHTML = RouteFooterBtns.map(function(item, index){
                        return(
                            <Button key={index} value={item} className="activate_btn_ok mx-2 border-0" onClick={handleModalClose}>
                                {item}
                            </Button>
                        );
                    });
                    setModalHeaderText(manageBtnNames[3]+" Alert");
                    setModalBodyHTML("Please select a single Trip from the second table.");
                    setModalBtnHTML(RouteFooterHTML);
                    setShowModal(true);
                }
                else
                {
                    let manageStopsData = manageTableStopsData[0].getData();
                    let manageMainData = mainManageTableData[0].getData();
                    let fsData = FundingSourceData[manageMainData.iATSPID]; //manageMainData.iATSPID

                    let fsOptionsHTML = JSON.parse(fsData).map(function(item, index){
                        let name = item.AccountID + " ("+ item.AffiliateAbbrevation+")";
                        let idVal = item.FID+"-"+item.iFSATSPID;
                        return(
                            <option key={idVal} value={idVal}>{name}</option>
                        );
                    });
                    setFSOptionsManageHTML(fsOptionsHTML);

                    let SRData = {
                        "iLockedID": parseInt(manageStopsData.TripNo)
                    }
                    xCancelSourceForGrid.current = APICom.GenerateSource();

                    setShowLoader(true);
                    let response = await APICom.fetchData("GenericManifestDotNetCoreURL","api/StandingRoute/GetStandingCustomerInfo", "post", {}, SRData, xCancelSourceForGrid.current);
                    if(response.data.length > 0)
                    {
                        let stopData = response.data[0];
                        setShowLoader(false);
                        setEditTripInfoManage({Phone:stopData.vPhoneNo,Name:stopData.vPickupPerson,
                            PUTime:stopData.vSchPU,ApptTime:stopData.vApptTime,PUSt:stopData.vPickupStreet,PUUnit:stopData.vPUUnit,PUCity:stopData.vPickupCity,
                            PUState:stopData.vPickupState, PUZip:parseInt(stopData.vPickupZip),PUZone:stopData.vPUZone,PUSchTime:stopData.dtSchedulePickTime,PULat:stopData.vPickLat,PULng:stopData.vPickLong,
                            DOSt:stopData.vDropOffStreet,DOUnit:stopData.vDOUnit,DOCity:stopData.vDropOffCity,DOState:stopData.vDropOffState, DOZip:parseInt(stopData.vDropOffZip),
                            DOZone: stopData.vDOZone, DOSchTime: stopData.dtScheduleDropTime, DOLat:stopData.vDropLat, DOLng:stopData.vDropLong, 
                            EstTime:stopData.dEstimatedTime, EstCost:(stopData.dEstimatedCost?stopData.dEstimatedCost:0), EstDist:stopData.dEstimatedDistance, Copay:stopData.dCopay, TotPass:stopData.nTotalPassengers, TotWC:stopData.nTotalWheelChairs, TotChildren:stopData.nTotalKids, FS:(stopData.iFundingSourceID+"-"+stopData.iRequestAffiliateID)}); //stopData.iRequestAffiliateID
                        setShowEditTripModal(true);
                    }
                    else
                    {
                        let RouteFooterBtns = ["OK"];
                        let RouteFooterHTML = RouteFooterBtns.map(function(item, index){
                            return(
                                <Button key={index} value={item} className="activate_btn_ok mx-2 border-0" onClick={handleModalClose}>
                                    {item}
                                </Button>
                            );
                        });
                        setModalHeaderText(manageBtnNames[3]+" Error");
                        setModalBodyHTML(response.error);
                        setModalBtnHTML(RouteFooterHTML);
                        setShowLoader(false);
                        setShowModal(true);
                    }
                }
            }
        }
        catch(err){console.log(err);}
    };

    const handleUpdateTimeManageScreen = async (e)=>{
        try{
            
            let manageTableStopData = manageSRStopsTableObject.current.getSelectedRows()[0].getData();
            let manageTableMainData = manageSRMainTableObject.current.getSelectedRows()[0].getData();
            // console.log(manageTableStopData);
            if(manageTableStopData.Type.toUpperCase() === "PU")
            {
                if(updateTimeInfoManage.SystemTime === "" || updateTimeInfoManage.requestedTime === "")
                {
                    let manageRouteFooterBtns = ["OK"];
                    let manageRouteFooterHTML = manageRouteFooterBtns.map(function(item, index){
                        return(
                            <Button key={index} value={item} className="activate_btn_ok mx-2 border-0" onClick={handleModalClose}>
                                {item}
                            </Button>
                        );
                    });
                    setModalHeaderText(manageBtnNames[2]+ " Alert");
                    setModalBodyHTML("Requested time or system scheduled time can not be empty!");
                    setModalBtnHTML(manageRouteFooterHTML);
                    setShowModal(true);
                    return 0;
                }
            }
            else
            {
                if(updateTimeInfoManage.SystemTime === "")
                {
                    let manageRouteFooterBtns = ["OK"];
                    let manageRouteFooterHTML = manageRouteFooterBtns.map(function(item, index){
                        return(
                            <Button key={index} value={item} className="activate_btn_ok mx-2 border-0" onClick={handleModalClose}>
                                {item}
                            </Button>
                        );
                    });
                    setModalHeaderText(manageBtnNames[2]+ " Alert");
                    setModalBodyHTML("System scheduled time can not be empty!");
                    setModalBtnHTML(manageRouteFooterHTML);
                    setShowModal(true);
                    return 0;
                }
            }
            
            let SRData = {
                "nodeType": manageTableStopData.Type,
                "reqTime": updateTimeInfoManage.requestedTime,
                "_schTime": updateTimeInfoManage.SystemTime,
                "_iLockedID": parseInt(manageTableStopData.TripNo)
            };
            
            xCancelSourceForGrid.current = APICom.GenerateSource();
            setShowLoader(true);
            let response = await APICom.fetchData("GenericManifestDotNetCoreURL","api/StandingRoute/UpdateStandingTimes", "post", {}, SRData, xCancelSourceForGrid.current);
            if(response.data.length > 0)
            {
                if(response.data[0].Result === "Success" && response.data[0].ErrorMsg.length === 0)
                {
                    let manageRouteFooterBtns = ["OK"];
                    let manageRouteFooterHTML = manageRouteFooterBtns.map(function(item, index){
                        return(
                            <Button key={index} value={item} className="activate_btn_ok mx-2 border-0" onClick={handleModalClose}>
                                {item}
                            </Button>
                        );
                    });
                    setModalHeaderText(manageBtnNames[2]+ " Successful!");
                    setModalBodyHTML("Time updated successfully for the selected trip.");
                    setModalBtnHTML(manageRouteFooterHTML);
                    setShowUpdateTimeDialog(false);
                    setShowLoader(false);
                    setShowModal(true);
                    initializeSRStopsTableManage(manageTableMainData);
                }
                else if(response.data[0].Result === "Fail" && response.data[0].ErrorMsg.length > 0)
                {
                    let manageRouteFooterBtns = ["OK"];
                    let manageRouteFooterHTML = manageRouteFooterBtns.map(function(item, index){
                        return(
                            <Button key={index} value={item} className="activate_btn_ok mx-2 border-0" onClick={handleModalClose}>
                                {item}
                            </Button>
                        );
                    });
                    let manageBodyHTML = function(index){
                        return(
                            <Row key={index}>
                                <Col dangerouslySetInnerHTML={{__html:response.data[0].ErrorMsg}}>
    
                                </Col>
                            </Row>
                        );
                    };
                    setModalHeaderText(manageBtnNames[2]+" Failed!");
                    setModalBodyHTML(manageBodyHTML);
                    setModalBtnHTML(manageRouteFooterHTML);
                    setShowUpdateTimeDialog(false);
                    setShowLoader(false);
                    setShowModal(true);
                }
                else
                {
                    let manageRouteFooterBtns = ["OK"];
                    let manageRouteFooterHTML = manageRouteFooterBtns.map(function(item, index){
                        return(
                            <Button key={index} value={item} className="activate_btn_ok mx-2 border-0" onClick={handleModalClose}>
                                {item}
                            </Button>
                        );
                    });
                    let manageBodyHTML = function(index){
                        return(
                            <Row key={index}>
                                <Col dangerouslySetInnerHTML={{__html:response.data[0].ErrorMsg}}>
    
                                </Col>
                            </Row>
                        );
                    };
                    setModalHeaderText(manageBtnNames[2]+" Failed!");
                    setModalBodyHTML(manageBodyHTML);
                    setModalBtnHTML(manageRouteFooterHTML);
                    setShowUpdateTimeDialog(false);
                    setShowLoader(false);
                    setShowModal(true);
                }
            }
            else
            {
                let manageRouteFooterBtns = ["OK"];
                let manageRouteFooterHTML = manageRouteFooterBtns.map(function(item, index){
                    return(
                        <Button key={index} value={item} className="activate_btn_ok mx-2 border-0" onClick={handleModalClose}>
                            {item}
                        </Button>
                    );
                });
                setModalHeaderText(manageBtnNames[2]+ " Failed!");
                setModalBodyHTML(response.error);
                setModalBtnHTML(manageRouteFooterHTML);
                setShowModal(true);
                setShowLoader(false);
            }
        }
        catch(err){console.log(err);}
    };

    const handleSaveEditTripChange = async (e)=>{
        try{
            let manageTableStopData = manageSRStopsTableObject.current.getSelectedRows()[0].getData();
            let manageTableMainData = manageSRMainTableObject.current.getSelectedRows()[0].getData();
            let SRData = {
                "_iLockedID": parseInt(manageTableStopData.TripNo),
                "phoneNo": editTripInfoManage.Phone,
                "name": editTripInfoManage.Name,
                "puTime": editTripInfoManage.PUTime,
                "apptTime": editTripInfoManage.ApptTime,
                "puStreet": editTripInfoManage.PUSt,
                "puCity": editTripInfoManage.PUCity,
                "puState": editTripInfoManage.PUState,
                "puZip": String(editTripInfoManage.PUZip),
                "puZone": editTripInfoManage.PUZone,
                "pickLat": parseFloat(editTripInfoManage.PULat),
                "puAppartNum": editTripInfoManage.PUUnit,
                "pickLong": parseFloat(editTripInfoManage.PULng),
                "sysSchPuTime": editTripInfoManage.PUSchTime,
                "doStreet": editTripInfoManage.DOSt,
                "doCity": editTripInfoManage.DOCity,
                "doState": editTripInfoManage.DOState,
                "doZip": String(editTripInfoManage.DOZip),
                "sysSchDOTime": editTripInfoManage.DOSchTime,
                "doAppartNum": editTripInfoManage.DOUnit,
                "doZone": editTripInfoManage.DOZone,
                "doLat": parseFloat(editTripInfoManage.DOLat),
                "doLong": parseFloat(editTripInfoManage.DOLng),
                "estTime": parseFloat(editTripInfoManage.EstTime),
                "estDistance": parseFloat(editTripInfoManage.EstDist),
                "estCost": parseFloat(editTripInfoManage.EstCost),
                "totalPassenger": parseInt(editTripInfoManage.TotPass),
                "wheelChair": parseInt(editTripInfoManage.TotWC),
                "totalKids": parseInt(editTripInfoManage.TotChildren),
                "copay": String(editTripInfoManage.Copay),
                "fundingSourceID": parseInt(editTripInfoManage.FS.split("-")[0])
            };
            
            xCancelSourceForGrid.current = APICom.GenerateSource();
            setShowLoader(true);
            let response = await APICom.fetchData("GenericManifestDotNetCoreURL","api/StandingRoute/UpdateEditTripInfo", "post", {}, SRData, xCancelSourceForGrid.current);
            if(response.data.length > 0)
            {
                if(response.data[0].Result === "Success" && response.data[0].ErrorMsg.length === 0)
                {
                    let manageRouteFooterBtns = ["OK"];
                    let manageRouteFooterHTML = manageRouteFooterBtns.map(function(item, index){
                        return(
                            <Button key={index} value={item} className="activate_btn_ok mx-2 border-0" onClick={handleModalClose}>
                                {item}
                            </Button>
                        );
                    });
                    setModalHeaderText("Save Successful!");
                    setModalBodyHTML("Trip updated successfully for the selected SR.");
                    setModalBtnHTML(manageRouteFooterHTML);
                    setShowEditTripModal(false);
                    setShowLoader(false);
                    setShowModal(true);
                    initializeSRStopsTableManage(manageTableMainData);
                }
                else if(response.data[0].Result === "Fail" && response.data[0].ErrorMsg.length > 0)
                {
                    let manageRouteFooterBtns = ["OK"];
                    let manageRouteFooterHTML = manageRouteFooterBtns.map(function(item, index){
                        return(
                            <Button key={index} value={item} className="activate_btn_ok mx-2 border-0" onClick={handleModalClose}>
                                {item}
                            </Button>
                        );
                    });
                    let manageBodyHTML = function(index){
                        return(
                            <Row key={index}>
                                <Col dangerouslySetInnerHTML={{__html:response.data[0].ErrorMsg}}>
    
                                </Col>
                            </Row>
                        );
                    };
                    setModalHeaderText("Save Failed!");
                    setModalBodyHTML(manageBodyHTML);
                    setModalBtnHTML(manageRouteFooterHTML);
                    setShowEditTripModal(false);
                    setShowLoader(false);
                    setShowModal(true);
                }
                else
                {
                    let manageRouteFooterBtns = ["OK"];
                    let manageRouteFooterHTML = manageRouteFooterBtns.map(function(item, index){
                        return(
                            <Button key={index} value={item} className="activate_btn_ok mx-2 border-0" onClick={handleModalClose}>
                                {item}
                            </Button>
                        );
                    });
                    let manageBodyHTML = function(index){
                        return(
                            <Row key={index}>
                                <Col dangerouslySetInnerHTML={{__html:response.data[0].ErrorMsg}}>
    
                                </Col>
                            </Row>
                        );
                    };
                    setModalHeaderText("Save Failed!");
                    setModalBodyHTML(manageBodyHTML);
                    setModalBtnHTML(manageRouteFooterHTML);
                    setShowEditTripModal(false);
                    setShowLoader(false);
                    setShowModal(true);
                }
            }
            else
            {
                let manageRouteFooterBtns = ["OK"];
                let manageRouteFooterHTML = manageRouteFooterBtns.map(function(item, index){
                    return(
                        <Button key={index} value={item} className="activate_btn_ok mx-2 border-0" onClick={handleModalClose}>
                            {item}
                        </Button>
                    );
                });
                setModalHeaderText("Save Failed!");
                setModalBodyHTML(response.error);
                setModalBtnHTML(manageRouteFooterHTML);
                setShowModal(true);
                setShowLoader(false);
            }
        }
        catch(err){console.log(err);}
    };

    const handleTitleClick = (e)=>{
        let targetStyle = "mx-1 px-2 activate_dialog_title_color fs-4 border border-bottom-0 rounded-top bg-light text-dark fw-bold";
        let resetStyle = "mx-1 px-2 activate_dialog_title_color fs-4";
        const ToolbarSelectedDate = props.selectedDate.split("-")[0]+"-"+(parseInt(props.selectedDate.split("-")[1])<10?
        "0"+parseInt(props.selectedDate.split("-")[1]):props.selectedDate.split("-")[1])+"-"+(parseInt(props.selectedDate.split("-")[2])<10?
        "0"+parseInt(props.selectedDate.split("-")[2]):props.selectedDate.split("-")[2]);
        if(e.target.textContent.toUpperCase() === "MANUAL DOWNLOAD")
        {
            setSRCreateTripsData([]);
            setManageSRStops([]);
            initializeSRTable(ToolbarSelectedDate);
            SRrowClickCreateGridCheck.current = "";
            ManageSRrowClickCreateGridCheckRef.current = "";
            e.target.className = targetStyle;
            const secondTitle = createSRTitle.current;
            secondTitle.className = resetStyle;
            const thirdTitle = manageSRTitle.current;
            thirdTitle.className = resetStyle;
            setShowSRManagePage(false);
            setShowStandingRoutePage(true);
            setShowStandingRouteCreatePage(false);
            setSelectedDate(ToolbarSelectedDate);
        }
        else if(e.target.textContent.toUpperCase() === "MANAGE")
        {
            setSRCreateTripsData([]);
            setStandingRouteStops([]);
            SRrowClickCreateGridCheck.current = "";
            SRrowClickCheck.current = "";
            initializeSRTableManage(ToolbarSelectedDate);
            // if(SRManageTableData.length === 0)
            // {
            //     initializeSRTableManage('');
            // }
            e.target.className = targetStyle;
            const secondTitle = createSRTitle.current;
            secondTitle.className = resetStyle;
            const firstTitle = manualDownloadTitle.current;
            firstTitle.className = resetStyle;
            setShowSRManagePage(true);
            setShowStandingRouteCreatePage(false);
            setShowStandingRoutePage(false);
            setSelectedDate(ToolbarSelectedDate);
        }
        else if(e.target.textContent.toUpperCase() === "CREATE")
        {
            setStandingRouteStops([]);
            setManageSRStops([]);
            SRrowClickCheck.current = "";
            ManageSRrowClickCreateGridCheckRef.current = "";
           

            setSelectedDateCreate(ToolbarSelectedDate);

            initializeSRCreateTable(ToolbarSelectedDate);
            // if(SRCreateTableData.length === 0)
            // {
            //     initializeSRCreateTable('');
            // }
            e.target.className = targetStyle;
            const firstTitle = manualDownloadTitle.current;
            firstTitle.className = resetStyle;
            const thirdTitle = manageSRTitle.current;
            thirdTitle.className = resetStyle;
            setShowSRManagePage(false);
            setShowStandingRoutePage(false);
            setShowStandingRouteCreatePage(true);
            setSelectedDate(ToolbarSelectedDate);
        }
    };
    
    useEffect(() => {
        if(SRSavedTableData.length === 0)
        {
            initializeSRTable('');
            // document.addEventListener("click", handleTableClick, false);
        }
        // console.log(SRDownloadMainTableRowSelection);
        return () => {
            // document.removeEventListener("click", handleTableClick, false);
        };
    }, []);

    useEffect(() => {
        if(ARBResponseForAdjustTime.length != null && manageSRStopsTableObject.current != null){
           let originalTableData = manageSRStopsTableObject.current.getData();
           for(let i = 0; i < originalTableData.length; i++){
                for(let j = 0; j < ARBResponseForAdjustTime.length; j++){
                    if(originalTableData[i].Index == String(parseInt(ARBResponseForAdjustTime[j].MVRecordID) +"_"+ ARBResponseForAdjustTime[j].NodeType)){
                        let systemSchTime = new Date(ARBResponseForAdjustTime[j].SystemScheduleTime);
                        const hours = systemSchTime.getHours().toString().padStart(2, '0');
                        const minutes = systemSchTime.getMinutes().toString().padStart(2, '0');
                        const formattedTime = `${hours}:${minutes}`;
                        manageSRStopsTableObject.current.updateRow(originalTableData[i]['Index'], {["SysSch Time"]:formattedTime, ["EstDist"]:ARBResponseForAdjustTime[j].EstTravelDistance, ["EstTime"]:ARBResponseForAdjustTime[j].EstTravelTime});
                    }
                }
           }
           setTimeout(() => {
            ValidateStandingRoute();
          }, 2000);
        }
        return () => {
        };
    }, [ARBResponseForAdjustTime]);

    useEffect(() => {
        if(ARBResponseForValidate.length != null && manageSRStopsTableObject.current != null){
           let originalTableData = manageSRStopsTableObject.current.getData();
           for(let i = 0; i < originalTableData.length; i++){
                let _violationHtml = "";
                for(let j = 0; j < ARBResponseForValidate.length; j++){
                    if(originalTableData[i].Index == String(parseInt(ARBResponseForValidate[j].TripNo) +"_"+ ARBResponseForValidate[j].StopType)){
                        if (ARBResponseForValidate[j].ViolationID == -1) {
                            _violationHtml += '<span style="background-color: '+ violationColors[0].capacity +';margin: 2px;color:white;">CV</span>';
                        } else if (ARBResponseForValidate[j].ViolationID == -2) {
                            _violationHtml += '<span style="background-color: '+ violationColors[0].timeWindow +';margin: 2px;color:white;">TWV</span>';
                        } else if (ARBResponseForValidate[j].ViolationID == -3) {
                            _violationHtml += '<span style="background-color:'+ violationColors[0].RideTime +';margin: 2px;color:white;">RTV</span>';
                        } else if (ARBResponseForValidate[j].ViolationID == -4) {
                            _violationHtml += '<span style="background-color:'+ violationColors[0].maxMilesHours +';margin:2px;color:white;">MMV</span>';
                        } else if (ARBResponseForValidate[j].ViolationID == -5) {
                            _violationHtml += '<span style="background-color:'+ violationColors[0].nonDrop +';margin: 2px;color:white;">NDV</span>';
                        } else if (ARBResponseForValidate[j].ViolationID == -6) {
                            _violationHtml += '<span style="background-color:'+ violationColors[0].driverBreak +';margin:2px;color:white;">DBV</span>';
                        } else if (ARBResponseForValidate[j].ViolationID == -7) {
                            _violationHtml += '<span style="background-color:'+ violationColors[0].puLoopBack +';margin: 2px;color:white;">PLV</span>';
                        } else if (ARBResponseForValidate[j].ViolationID == -8) {
                            _violationHtml += '<span style="background-color:#000000;margin: 2px;color:white;">TIV</span>';
                        } else if (ARBResponseForValidate[j].ViolationID == -9) {
                            _violationHtml += '<span style="background-color:'+ violationColors[0].uniqueStops +';margin: 2px;color:white;">USV</span>';
                        } else if (ARBResponseForValidate[j].ViolationID == -10) {
                            _violationHtml += '<span style="background-color:'+ violationColors[0].TripStartTime +';margin: 2px;color:white;">EST</span>';
                        } else if (ARBResponseForValidate[j].ViolationID == -11) {
                            _violationHtml += '<span style="background-color:'+ violationColors[0].maxRouteHrs +';margin: 2px;color:white;">RHV</span>';
                        } else if (ARBResponseForValidate[j].ViolationID == -12) {
                            _violationHtml += '<span style="background-color:'+ violationColors[0].MaxTrips +';margin: 2px;color:white;">MTV</span>';
                        } else if (ARBResponseForValidate[j].ViolationID == -13) {
                            _violationHtml += '<span style="background-color:'+ violationColors[0].invalidPUGPS +';margin:2px;color:white;">PGPSV</span>';
                        } else if (ARBResponseForValidate[j].ViolationID == -14) {
                            _violationHtml += '<span style="background-color:'+ violationColors[0].invalidDOGPS +';margin:2px;color:white;">DGPSV</span>';
                        } else if (ARBResponseForValidate[j].ViolationID == -15) {
                            _violationHtml += '<span style="background-color:'+ violationColors[0].WillCallTrip +';margin:2px;color:white;">WCV</span>';
                        } else if (ARBResponseForValidate[j].ViolationID == -16) {
                            _violationHtml += '<span style="background-color:'+ violationColors[0].RideSharing +';margin:2px;color:white;">RSV</span>';
                        }
                    }
                }
                manageSRStopsTableObject.current.updateRow(originalTableData[i]['Index'], {Violation: _violationHtml});
            }
        }
        return () => {
        };
    }, [ARBResponseForValidate]);
    
    return(
        <> 
        {/* General Standing Route Modal (Manage & Create) */}
        
        {props.showStandingRouteDialog &&
            <Modal show={props.showStandingRouteDialog} centered size="xl" 
            aria-labelledby="contained-modal-title-vcenter" animation={true} keyboard={true} onHide={handleClose} backdrop="static" >
                <Modal.Header className='pb-0 activate_dialog_header_bgcolor user-select-none' closeButton>
                    <Modal.Title ref={manualDownloadTitle} title="Download Standing Routes" className="mx-1 px-2 activate_dialog_title_color fs-4 border border-bottom-0 rounded-top bg-light text-dark fw-bold" onClick={handleTitleClick} style={{cursor:"pointer"}}>
                        Manual Download
                    </Modal.Title>
                    <Modal.Title ref={manageSRTitle} title="Manage Standing Routes" className="mx-1 px-2 activate_dialog_title_color fs-4" onClick={handleTitleClick} style={{cursor:"pointer"}}>
                        Manage
                    </Modal.Title>
                    <Modal.Title ref={createSRTitle} title="Create & Save Standing Routes" className="mx-1 px-2 activate_dialog_title_color fs-4" onClick={handleTitleClick} style={{cursor:"pointer"}}>
                        Create
                    </Modal.Title>
                    <Modal.Title className="text-center px-2 activate_dialog_title_color fs-4 user-select-none border-4 border-top-0 rounded-bottom" style={{cursor:"default", marginLeft:"5%", marginTop:"-2.5%", borderStyle:"groove"}}>
                        Standing Routes
                    </Modal.Title>
                </Modal.Header>
                
                    {/* Download SR */}
                    {showStandingRoutePage ? 
                    <>
                        <Modal.Body className="grid-example">
                            <Row className="d-flex">
                                <Col className="justify-content-end d-flex">
                                    <input type="date" className="text-center mb-2" value={selectedDate} placeholder={state.placeholder} style={state.styles} disabled={state.disable}  onChange={handleDateChange}/>
                                </Col>
                            </Row>
                            
                           {SRSavedTableData && SRSavedTableData.length > 0 ? 
                                <Row className="m-0">
                                    <GridControl ShowLoader={showLoader} ReloadDataFunction={handleStandingRoutesOpen} Data={SRSavedTableData} options={standingRouteGridOptions}/>
                                </Row> 
                            : <p className={`user-select-none m-0 text-danger fw-bold text-center ${showLoader ? 'd-none':''}`}>{"No data is available for this action..."}</p>}
                           <Row className="opacity-0" ref={SRStopsGrid}>
                                <GridControl ShowLoader={showLoader} ReloadDataFunction={handleStandingRoutesOpen}  Data={standingRouteStops} options={standingRouteStopsGridOptions}/>
                           </Row>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button className="activate_btn_ok border-0" disabled={(!SRSavedTableData || SRSavedTableData.length === 0)} onClick={handleDownloadRouteOpen}>
                                {downloadBtnNames[0]}
                            </Button>
                        </Modal.Footer>
                    </>:""}   

                    {/* Manage SR */}
                    {showSRManagePage ? 
                    <>
                        <Modal.Body className="grid-example">
                            <Row className="d-flex">
                                {/* <Col className="justify-content-start d-flex">
                                    <p className="my-auto p-2 pe-none user-select-none" style={{fontSize:"small"}}>Mandatory Vehicle</p>
                                    <input type="checkbox" onClick={handleCheckMandVehicle} style={{cursor:"pointer"}}/> */}
                                    {/* <Col className="mx-2 mb-2 border border-dark rounded">
                                        <div className="rounded w-25 text-muted mx-2 user-select-none" style={{backgroundColor:"white", marginTop:"-3%"}}>Day Selection</div>
                                        <Row>
                                            <Col>
                                                <Col className="d-inline-flex px-1">
                                                    <input className="mx-1" type="checkbox" value={"Mon"} style={{cursor:"pointer"}} onClick={handleDaysChanged}/><label className="user-select-none">Mon</label>
                                                </Col>
                                                <Col className="d-inline-flex px-1">
                                                    <input className="mx-1" type="checkbox" value={"Tue"} style={{cursor:"pointer"}} onClick={handleDaysChanged}/><label className="user-select-none">Tue</label>
                                                </Col>
                                                <Col className="d-inline-flex px-1">
                                                    <input className="mx-1" type="checkbox" value={"Wed"} style={{cursor:"pointer"}} onClick={handleDaysChanged}/><label className="user-select-none">Wed</label>
                                                </Col>
                                                <Col className="d-inline-flex px-1">
                                                    <input className="mx-1" type="checkbox" value={"Thu"} style={{cursor:"pointer"}} onClick={handleDaysChanged}/><label className="user-select-none">Thu</label>
                                                </Col>
                                                <Col className="d-inline-flex px-1">
                                                    <input className="mx-1" type="checkbox" value={"Fri"} style={{cursor:"pointer"}} onClick={handleDaysChanged}/><label className="user-select-none">Fri</label>
                                                </Col>
                                                <Col className="d-inline-flex px-1">
                                                    <input className="mx-1" type="checkbox" value={"Sat"} style={{cursor:"not-allowed"}} disabled/><label className="user-select-none">Sat</label>
                                                </Col>
                                                <Col className="d-inline-flex px-1">
                                                    <input className="mx-1" type="checkbox" value={"Sun"} style={{cursor:"not-allowed"}} disabled/><label className="user-select-none">Sun</label>
                                                </Col>
                                                
                                            </Col>
                                            
                                        </Row>
                                    </Col> */}
                                {/* </Col> */}
                                <Col className="justify-content-end d-flex">
                                    <input type="date" className="text-center mb-2" value={selectedDateManage} placeholder={state.placeholder} style={state.styles} disabled={state.disable}  onChange={handleDateChangeManage}/>
                                </Col>
                            </Row>
                            {SRManageTableData && SRManageTableData.length > 0 ?
                                <>
                                    <Row className="m-0">
                                            <GridControl ShowLoader={showLoader} ReloadDataFunction={handleStandingRoutesOpen} Data={SRManageTableData} options={manageSRGridOptions}/>
                                    </Row>
                                    <Row className="opacity-0" ref={ManageStopsGrid}>
                                            <GridControl ShowLoader={showLoader} ReloadDataFunction={handleStandingRoutesOpen}  Data={manageSRStops} options={manageSRStopOrderGridOptions}/>
                                    </Row>
                                </>
                            : <p className={`user-select-none m-0 text-danger fw-bold text-center ${showLoader ? 'd-none':''}`}>{"No data is available for this action..."}</p>}
                        </Modal.Body>
                        <Modal.Footer>
                            
                            <Button className="activate_btn_ok border-0 text-nowrap" disabled={(!SRManageTableData || SRManageTableData.length === 0)} onClick={handleUpdateSettingModalOpen}>
                                {manageBtnNames[0]}
                            </Button>
                            <Button className="activate_btn_ok border-0 text-nowrap" disabled={(!SRManageTableData || SRManageTableData.length === 0)} onClick={handleRemoveTripsOrRouteModalOpen}>
                                {manageBtnNames[1]}
                            </Button>
                            <Button className="activate_btn_ok border-0 text-nowrap" disabled={(!SRManageTableData || SRManageTableData.length === 0)} onClick={handleUpdateTimeModalOpen}>
                                {manageBtnNames[2]}
                            </Button>
                            <Button className="activate_btn_ok border-0 text-nowrap" disabled={(!SRManageTableData || SRManageTableData.length === 0)} onClick={handleEditTripModalOpen}>
                                {manageBtnNames[3]}
                            </Button>
                            <Button className="activate_btn_ok border-0 text-nowrap" disabled={(!SRManageTableData || SRManageTableData.length === 0)} onClick={handlePrescheduleModalOpen}>
                                {manageBtnNames[4]}
                            </Button>
                        </Modal.Footer>
                    </>:""}   

                    {/* Create & Save SR Pg*/}   
                    {showStandingRouteCreatePage ? <>
                        <Modal.Body className="grid-example">
                            {/* <div className="bg-info w-100" style={{height:"300px"}}></div> */}
                            {SRCreateTableData && SRCreateTableData.length > 0 ?
                                <>
                                    <Row className="m-0">
                                        <GridControl ShowLoader={showLoader} ReloadDataFunction={handleStandingRoutesOpen} Data={SRCreateTableData} options={SRCreateGridOptions}/>
                                    </Row>
                                    <Row className="opacity-0" ref={SRCreateStops}>
                                        <GridControl ShowLoader={showLoader} ReloadDataFunction={handleStandingRoutesOpen}  Data={SRCreateTripsData} options={SRCreateStopsGridOptions}/>
                                    </Row>
                                </> 
                           : <p className={`user-select-none m-0 text-danger fw-bold text-center ${showLoader ? 'd-none':''}`}>{"No data exists for update..."}</p>}
                        </Modal.Body>
                        <Modal.Footer>
                            <Col>
                                <Button className="activate_btn_ok border-0" id={"CreateBtn"} onClick={handleSaveUpdateModalOpen}>
                                    Create
                                </Button>
                                <Button className="activate_btn_ok mx-2 border-0" id={"UpdateBtn_CreatePg"} disabled={(!SRCreateTripsData || SRCreateTripsData.length === 0)} onClick={handleSaveUpdateModalOpen}>
                                    Update
                                </Button>
                            </Col>
                            
                            <Button className="activate_btn_ok border-0" onClick={handleRefreshClick}>
                                Refresh
                            </Button>
                            <input type="date" className="text-center" value={selectedDateCreate} placeholder={state.placeholder} style={state.styles} disabled={state.disable}  onChange={handleDateChangeCreate}/>
                        </Modal.Footer>
                    </>:""}
    
                
            </Modal>
            }

            {/* The following is for Save/Update Additional Info Modal */}
            {showSaveModal ? <Modal show={showSaveModal} centered
            aria-labelledby="contained-modal-title-vcenter" animation={true} keyboard={true} onHide={()=>{setShowSaveModal(false);}} backdrop="static">
                <Modal.Header className='pb-0 activate_dialog_header_bgcolor user-select-none' closeButton>
                    <Modal.Title className="activate_dialog_title_color text-nowrap">
                        {saveModalTitle}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="grid-example">
                    <Row>
                        <Col xs={4}>
                            <p className="fw-bold text-nowrap">SR Name:</p>
                        </Col>
                        <Col xs={8}>
                            <input type="text" className="w-100" value={updateCreateInfo.Name} onChange={(e)=>{setUpdateCreateInfo({...updateCreateInfo,Name:e.target.value});}} disabled={saveModalTitle.split(" ")[0].toLowerCase() === "create"? false: true}/>
                        </Col>
                    </Row>
                    <div className="position-relative p-1 text-start pe-none user-select-none text-secondary rounded text-nowrap" style={{zIndex:"999", top:"-18px", backgroundColor:"white", fontSize:"small", height:"20px", width:"11%"}}>SR Info</div>
                    <Row className="border border-secondary rounded p-2" style={{marginTop:"-5%"}}>
                        <Row>
                            <Col xs={2}>
                                <p className="fw-normal text-nowrap user-select-none">Route:</p>
                            </Col>
                            <Col xs={5}>
                            <div title={updateCreateInfo.route} className="w-100">
                             {updateCreateInfo.route}
                             </div>
                                </Col>
                            <Col xs={2}>
                                <p className="fw-normal text-nowrap user-select-none">Vehicle:</p>
                            </Col>
                            <Col xs={3}>
                                <select type="text" className="w-100 text-center" defaultValue={updateCreateInfo.vehicle} onChange={(e)=>{setUpdateCreateInfo({...updateCreateInfo,vehicle:e.target.value});}}>
                                    {vehOptionsManageHTML}
                                </select>
                            </Col>
                        </Row>
                    </Row>
                    <div className="position-relative p-1 text-start pe-none user-select-none text-secondary rounded" style={{zIndex:"9999", top:"0px", backgroundColor:"white", fontSize:"small", height:"20px", width:"19%"}}>Day Selection</div>
                    <Row className="border border-dark rounded" style={{marginTop:"-1%"}}>
                        
                        <Row className="p-1 mx-1">
                            
                            <Col className="d-inline-flex px-1">
                                <input className="mx-1" type="checkbox" value={"Mon"} style={{cursor:"pointer"}} checked={CreateDaysSelected.Mon} onChange={(e)=>{handleDayChangeofCreate(e.target.value, e.target.checked)}}/><label className="user-select-none">Mon</label>
                            </Col>
                            <Col className="d-inline-flex px-1">
                                <input className="mx-1" type="checkbox" value={"Tue"} style={{cursor:"pointer"}} checked={CreateDaysSelected.Tue} onChange={(e)=>{handleDayChangeofCreate(e.target.value, e.target.checked)}}/><label className="user-select-none">Tue</label>
                            </Col>
                            <Col className="d-inline-flex px-1">
                                <input className="mx-1" type="checkbox" value={"Wed"} style={{cursor:"pointer"}} checked={CreateDaysSelected.Wed} onChange={(e)=>{handleDayChangeofCreate(e.target.value, e.target.checked)}}/><label className="user-select-none">Wed</label>
                            </Col>
                            <Col className="d-inline-flex px-1">
                                <input className="mx-1" type="checkbox" value={"Thu"} style={{cursor:"pointer"}} checked={CreateDaysSelected.Thu} onChange={(e)=>{handleDayChangeofCreate(e.target.value, e.target.checked)}}/><label className="user-select-none">Thu</label>
                            </Col>
                            <Col className="d-inline-flex px-1">
                                <input className="mx-1" type="checkbox" value={"Fri"} style={{cursor:"pointer"}} checked={CreateDaysSelected.Fri} onChange={(e)=>{handleDayChangeofCreate(e.target.value, e.target.checked)}}/><label className="user-select-none">Fri</label>
                            </Col>
                            <Col className="d-inline-flex px-1">
                                <input className="mx-1" type="checkbox" value={"Sat"} style={{cursor:"pointer"}} checked={CreateDaysSelected.Sat} onChange={(e)=>{handleDayChangeofCreate(e.target.value, e.target.checked)}}/><label className="user-select-none">Sat</label>
                            </Col>
                            <Col className="d-inline-flex px-1">
                                <input className="mx-1" type="checkbox" value={"Sun"} style={{cursor:"pointer"}} checked={CreateDaysSelected.Sun} onChange={(e)=>{handleDayChangeofCreate(e.target.value, e.target.checked)}}/><label className="user-select-none">Sun</label>
                            </Col>
                        </Row>
                    </Row>
                    <div className="position-relative p-1 text-start pe-none user-select-none text-secondary rounded text-nowrap" style={{zIndex:"999", top:"0px", backgroundColor:"white", fontSize:"small", height:"24px", width:"21%"}}>Auto Download</div>
                    <Row className="border border-secondary rounded p-2" style={{marginTop:"-2%"}}>
                        
                        <Col>
                            <p className="fw-normal text-nowrap pe-none user-select-none" style={{fontSize:"small"}}>From:</p>
                            <p className="fw-normal text-nowrap pe-none user-select-none" style={{fontSize:"small"}}>To:</p>
                            
                        </Col>
                        <Col>
                            <input type="date" value={updateCreateInfo.From} onChange={(e)=>{setUpdateCreateInfo({...updateCreateInfo,From:e.target.value});}} className="text-center" placeholder={state.placeholder}/>
                            <input type="date" value={updateCreateInfo.To} onChange={(e)=>{setUpdateCreateInfo({...updateCreateInfo,To:e.target.value});}} className="text-center mt-1" placeholder={state.placeholder}/>
                        </Col>
                        
                        
                        <Col xs={6}>
                            <Row>
                                <Col xs={2} className="my-1">
                                    <input type="checkbox" checked={updateCreateInfo.Auto} onChange={(e)=>{setUpdateCreateInfo({...updateCreateInfo,Auto:e.target.checked});}} className="" style={{cursor:"pointer"}}/>
                                </Col>
                                <Col xs={10} className="my-1">
                                    <div className="fw-bold text-nowrap pe-none user-select-none" style={{fontSize:"small"}}>Auto Download Service</div>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={2}>
                                    <input type="checkbox" checked={updateCreateInfo.InsertMissing} onChange={(e)=>{setUpdateCreateInfo({...updateCreateInfo,InsertMissing:e.target.checked});}} style={{cursor:"pointer"}}/>
                                </Col>
                                <Col xs={10}>
                                    <div className="fw-bold text-nowrap pe-none user-select-none" style={{fontSize:"small"}}>Insert Missing Trips</div>
                                </Col>
                                
                            </Row>
                            
                        </Col>

                        <Row>
                            <Col xs={4}>
                                <p className="fw-normal text-nowrap pe-none user-select-none" style={{fontSize:"small"}}>SR Type:</p>
                            </Col>
                            <Col xs={8}>
                                <select defaultValue={updateCreateInfo.SRType} onChange={(e)=>{setUpdateCreateInfo({...updateCreateInfo,SRType:e.target.value});}} className="w-100 text-center">
                                    <option value={"default"} disabled hidden>Please choose a route type</option>
                                    <option value={"2"}>Locked</option>
                                    <option value={"3"}>Blocked</option>
                                    <option value={"1"}>UnLocked</option>
                                </select>
                            </Col>
                        </Row>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button className="activate_btn_ok border-0" onClick={handleSaveUpdateStandingRoutes}>
                        {saveModalTitle.split(" ")[0]}
                    </Button>
                    <Button className="bg-secondary border-0" onClick={()=>setShowSaveModal(false)}>
                        Cancel
                    </Button>
                </Modal.Footer>
            </Modal>:""}
            {showModal ? <Modal centered backdrop="static" keyboard={true} onHide={handleModalClose} show={showModal} animation={true}>
                            <Modal.Header closeButton>
                                <Modal.Title>{modalHeaderText}</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>{modalBodyHTML}</Modal.Body>
                            <Modal.Footer>
                                
                                {modalBtnHTML}
                                
                            </Modal.Footer>
                        </Modal>: ""}
            {showDownloadDialogue ? 
                <Modal centered backdrop="static" keyboard={true} onHide={()=>setShowDownloadDialogue(false)} show={showDownloadDialogue} animation={true}>
                    <Modal.Header closeButton>
                        <Modal.Title>{downloadBtnNames[0]}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Row>
                            <Col className="d-flex">
                                <input type="radio" style={{cursor:"pointer"}} className="radio_download" name="radio_download" checked={downloadRouteRadioChecked === 1} onChange={handleDownloadRadioCheck} value={1}/><label className="mx-2 user-select-none text-nowrap"style={{fontSize:"small"}}>Insert Missing Trips</label>
                            </Col>
                            <Col className="d-flex">
                                <input type="radio" style={{cursor:"pointer"}} className="radio_download" name="radio_download" checked={downloadRouteRadioChecked === 2} onChange={handleDownloadRadioCheck} value={2}/><label className="mx-2 user-select-none text-nowrap" style={{fontSize:"small"}}>Do Not Insert Missing Trips</label>
                            </Col>
                            <Col className="justify-content-start d-flex">
                                <input type="checkbox" onClick={handleCheckMandVehicle} style={{cursor:"pointer"}}/>
                                <p className="my-auto p-2 pe-none user-select-none text-nowrap" style={{fontSize:"small"}}>Mandatory Vehicle</p>
                            </Col>
                        </Row>
                    </Modal.Body>
                    <Modal.Footer>
                        
                        <Button className="activate_btn_ok mx-2 border-0" onClick={handleDownloadRouteOperation}>
                            Download
                        </Button>
                        <Button className="activate_btn_ok mx-2 border-0" onClick={()=>setShowDownloadDialogue(false)}>
                            Cancel
                        </Button>
                    </Modal.Footer>
                </Modal>: ""}

                {showUpdateTimeDialog ? 
                <Modal centered backdrop="static" keyboard={true} size="sm" onHide={()=>setShowUpdateTimeDialog(false)} show={showUpdateTimeDialog} animation={true}>
                    <Modal.Header closeButton>
                        <Modal.Title>Update Time</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Row>
                            <Col xs={6}>
                                <p className="fw-normal text-nowrap pe-none user-select-none" style={{fontSize:"small"}}>Requested Time:</p>
                                <p className="fw-normal text-nowrap pe-none user-select-none" style={{fontSize:"small"}}>System Scheduled Time:</p>
                                
                            </Col>
                            <Col className="position-relative" xs={6}>
                                <input type="time" value={updateTimeInfoManage.requestedTime} onChange={(e)=>{setUpdateTimeInfoManage({...updateTimeInfoManage,requestedTime:e.target.value});}} className="text-center d-block " placeholder={state.placeholder}/>
                                <input type="time" value={updateTimeInfoManage.SystemTime} onChange={(e)=>{setUpdateTimeInfoManage({...updateTimeInfoManage,SystemTime:e.target.value});}} className="text-center mt-1 d-block " placeholder={state.placeholder}/>
                            </Col>
                        </Row>
                    </Modal.Body>
                    <Modal.Footer>
                        
                        <Button className="activate_btn_ok mx-2 border-0" onClick={handleUpdateTimeManageScreen}>
                            Save
                        </Button>
                        <Button className="activate_btn_ok mx-2 border-0" onClick={()=>setShowUpdateTimeDialog(false)}>
                            Cancel
                        </Button>
                    </Modal.Footer>
                </Modal>: ""}

            {showPreScheduleModal ? 
                <Modal centered backdrop="static" keyboard={true} size="lg" onHide={()=>setShowPreScheduleModal(false)} show={showPreScheduleModal} animation={true}>
                    <Modal.Header closeButton>
                        <Modal.Title>Preset Schedule</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="position-relative p-1 text-start pe-none user-select-none text-secondary rounded text-nowrap" style={{zIndex:"9999", top:"-16px", backgroundColor:"white", fontSize:"small", height:"20px", width:"11%"}}>Day Selection</div>
                        <Row className="border border-dark rounded" style={{marginTop:"-3%"}}>
                            
                            <Row className="p-1 mx-1">
                                
                                <Col className="d-inline-flex px-1">
                                    <input className="mx-1" type="checkbox" value={"Mon"} style={{cursor:"pointer"}} disabled={!(disabledDatesManageCheck.Mon.split(",")[0]==="true"?true:false)} checked={(manageTripDaysSelected.Mon.split(",")[0]==="true"?true:false)} onChange={(e)=>{handleDayChangeTripPrescheduleManage(e.target.value, e.target.checked)}}/><label className="user-select-none">Mon</label>
                                </Col>
                                <Col className="d-inline-flex px-1">
                                    <input className="mx-1" type="checkbox" value={"Tue"} style={{cursor:"pointer"}} disabled={!(disabledDatesManageCheck.Tue.split(",")[0]==="true"?true:false)} checked={(manageTripDaysSelected.Tue.split(",")[0]==="true"?true:false)} onChange={(e)=>{handleDayChangeTripPrescheduleManage(e.target.value, e.target.checked)}}/><label className="user-select-none">Tue</label>
                                </Col>
                                <Col className="d-inline-flex px-1">
                                    <input className="mx-1" type="checkbox" value={"Wed"} style={{cursor:"pointer"}} disabled={!(disabledDatesManageCheck.Wed.split(",")[0]==="true"?true:false)} checked={(manageTripDaysSelected.Wed.split(",")[0]==="true"?true:false)} onChange={(e)=>{handleDayChangeTripPrescheduleManage(e.target.value, e.target.checked)}}/><label className="user-select-none">Wed</label>
                                </Col>
                                <Col className="d-inline-flex px-1">
                                    <input className="mx-1" type="checkbox" value={"Thu"} style={{cursor:"pointer"}} disabled={!(disabledDatesManageCheck.Thu.split(",")[0]==="true"?true:false)} checked={(manageTripDaysSelected.Thu.split(",")[0]==="true"?true:false)} onChange={(e)=>{handleDayChangeTripPrescheduleManage(e.target.value, e.target.checked)}}/><label className="user-select-none">Thu</label>
                                </Col>
                                <Col className="d-inline-flex px-1">
                                    <input className="mx-1" type="checkbox" value={"Fri"} style={{cursor:"pointer"}} disabled={!(disabledDatesManageCheck.Fri.split(",")[0]==="true"?true:false)} checked={(manageTripDaysSelected.Fri.split(",")[0]==="true"?true:false)} onChange={(e)=>{handleDayChangeTripPrescheduleManage(e.target.value, e.target.checked)}}/><label className="user-select-none">Fri</label>
                                </Col>
                                <Col className="d-inline-flex px-1">
                                    <input className="mx-1" type="checkbox" value={"Sat"} style={{cursor:"pointer"}} disabled={!(disabledDatesManageCheck.Sat.split(",")[0]==="true"?true:false)} checked={(manageTripDaysSelected.Sat.split(",")[0]==="true"?true:false)} onChange={(e)=>{handleDayChangeTripPrescheduleManage(e.target.value, e.target.checked)}}/><label className="user-select-none">Sat</label>
                                </Col>
                                <Col className="d-inline-flex px-1">
                                    <input className="mx-1" type="checkbox" value={"Sun"} style={{cursor:"pointer"}} disabled={!(disabledDatesManageCheck.Sun.split(",")[0]==="true"?true:false)} checked={(manageTripDaysSelected.Sun.split(",")[0]==="true"?true:false)} onChange={(e)=>{handleDayChangeTripPrescheduleManage(e.target.value, e.target.checked)}}/><label className="user-select-none">Sun</label>
                                </Col>
                            </Row>
                        </Row>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button className="activate_btn_ok mx-2 border-0" onClick={handlePrescheduleUpdateOnManageTrip}>
                            Preset Schedule
                        </Button>
                        <Button className="activate_btn_ok mx-2 border-0" onClick={()=>setShowPreScheduleModal(false)}>
                            Cancel
                        </Button>
                    </Modal.Footer>
                </Modal>
            :""}
            {showEditTripModal ? 
                <Modal centered backdrop="static" className="overflow-auto" keyboard={true} size="lg" onHide={()=>setShowEditTripModal(false)} show={showEditTripModal} animation={true}>
                    <Modal.Header closeButton>
                        <Modal.Title className="user-select-none pe-auto">Edit SR Trip</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="position-relative p-1 mt-1 text-start pe-none user-select-none text-dark rounded text-nowrap fw-bold border" style={{zIndex:"9999", top:"-17px", backgroundColor:"lightskyblue", fontSize:"small", height:"2%", width:"9%"}}>Rider Info</div>
                        <Row className="border border-dark pt-2 rounded" style={{marginTop:"-4%", backgroundColor:"#e8f9fd"}}>
                            <Row className="p-1 mx-1">
                                <Col xs={1}>
                                    <p className="fw-normal text-nowrap pe-none user-select-none" style={{fontSize:"small"}}>Phone:</p>
                                    <p className="fw-normal text-nowrap pe-none user-select-none" style={{fontSize:"small"}}>PU Time:</p>
                                </Col>
                                <Col xs={5}>
                                    <input type="tel" value={editTripInfoManage.Phone} onChange={(e)=>{setEditTripInfoManage({...editTripInfoManage,Phone:e.target.value});}} className="text-center d-block rounded border-1" placeholder={state.placeholder}/>
                                    <input type="time" value={editTripInfoManage.PUTime} onChange={(e)=>{setEditTripInfoManage({...editTripInfoManage,PUTime:e.target.value});}} className="text-center mt-2 d-block rounded border-1" placeholder={state.placeholder}/>
                                </Col>
                                <Col xs={2}>
                                    <p className="fw-normal text-nowrap pe-none user-select-none" style={{fontSize:"small"}}>Name:</p>
                                    <p className="fw-normal text-nowrap pe-none user-select-none" style={{fontSize:"small"}}>Appointment Time:</p>
                                </Col>
                                <Col xs={4}>
                                    <input type="text" value={editTripInfoManage.Name} onChange={(e)=>{setEditTripInfoManage({...editTripInfoManage,Name:e.target.value});}} className="text-start d-block rounded border-1" placeholder={state.placeholder}/>
                                    <input type="time" value={editTripInfoManage.ApptTime} onChange={(e)=>{setEditTripInfoManage({...editTripInfoManage,ApptTime:e.target.value});}} className="text-center mt-2 d-block rounded border-1" placeholder={state.placeholder}/>
                                </Col>
                                
                            </Row>
                        </Row>
                        <div className="position-relative p-1 mt-1 text-start pe-none user-select-none text-dark rounded text-nowrap fw-bold border" style={{zIndex:"999", top:"0px", backgroundColor:"lightskyblue", fontSize:"small", height:"2%", width:"8%"}}>Pick Info</div>
                        <Row className="border border-secondary rounded p-2 pb-0" style={{marginTop:"-2%", backgroundColor:"#e8f9fd"}}>
                            <Row className="p-1 mx-1">
                                <Col xs={1}>
                                    <p className="fw-normal text-nowrap pe-none user-select-none" style={{fontSize:"small"}}>Street:</p>
                                    <p className="fw-normal text-nowrap pe-none user-select-none" style={{fontSize:"small"}}>Unit:</p>
                                    <p className="fw-normal text-nowrap pe-none user-select-none" style={{fontSize:"small"}}>City:</p>
                                    <p className="fw-normal text-nowrap pe-none user-select-none" style={{fontSize:"small"}}>State:</p>
                                    <p className="fw-normal text-nowrap pe-none user-select-none" style={{fontSize:"small"}}>Zip:</p>
                                    <p className="fw-normal text-nowrap pe-none user-select-none" style={{fontSize:"small"}}>Zone:</p>
                                </Col>
                                <Col xs={5}>
                                    <input type="text" value={editTripInfoManage.PUSt} onChange={(e)=>{setEditTripInfoManage({...editTripInfoManage,PUSt:e.target.value});}} className="text-start d-block rounded border-1" placeholder={state.placeholder}/>
                                    <input type="text" value={editTripInfoManage.PUUnit} onChange={(e)=>{setEditTripInfoManage({...editTripInfoManage,PUUnit:e.target.value});}} className="text-center mt-2 d-block rounded border-1" placeholder={state.placeholder}/>
                                    <input type="text" value={editTripInfoManage.PUCity} onChange={(e)=>{setEditTripInfoManage({...editTripInfoManage,PUCity:e.target.value});}} className="text-center mt-2 d-block rounded border-1" placeholder={state.placeholder}/>
                                    <input type="text" value={editTripInfoManage.PUState} onChange={(e)=>{setEditTripInfoManage({...editTripInfoManage,PUState:e.target.value});}} className="text-center mt-2 d-block rounded border-1" placeholder={state.placeholder}/>
                                    <input type="text" maxLength={5} onInput={(e)=>{e.target.value = e.target.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');}} value={isNaN(editTripInfoManage.PUZip)?"0":editTripInfoManage.PUZip} onChange={(e)=>{setEditTripInfoManage({...editTripInfoManage,PUZip:e.target.value});}} className="text-center mt-2 d-block rounded border-1" placeholder={state.placeholder}/>
                                    <input type="text" value={editTripInfoManage.PUZone} onChange={(e)=>{setEditTripInfoManage({...editTripInfoManage,PUZone:e.target.value});}} className="text-center mt-2 d-block rounded border-1" placeholder={state.placeholder}/>
                                </Col>
                                <Col xs={2}>
                                    <p className="fw-normal text-nowrap pe-none user-select-none" style={{fontSize:"small"}}>System Sch. PU Time:</p>
                                    <p className="fw-normal text-nowrap pe-none user-select-none" style={{fontSize:"small"}}>Latitude:</p>
                                    <p className="fw-normal text-nowrap pe-none user-select-none" style={{fontSize:"small"}}>Longitude:</p>
                                </Col>
                                <Col xs={4}>
                                    <input type="time" value={editTripInfoManage.PUSchTime} onChange={(e)=>{setEditTripInfoManage({...editTripInfoManage,PUSchTime:e.target.value});}} className="text-center d-block rounded border-1" placeholder={state.placeholder}/>
                                    <input type="text" value={editTripInfoManage.PULat} onChange={(e)=>{setEditTripInfoManage({...editTripInfoManage,PULat:e.target.value});}} className="text-center mt-2 d-block rounded border-1" placeholder={state.placeholder}/>
                                    <input type="text" value={editTripInfoManage.PULng} onChange={(e)=>{setEditTripInfoManage({...editTripInfoManage,PULng:e.target.value});}} className="text-center mt-2 d-block rounded border-1" placeholder={state.placeholder}/>
                                    <Button type="button" title="Verify address on google maps" disabled onClick={(e)=>{}} className="activate_btn_ok mt-2 border-0" placeholder={state.placeholder}>Verify</Button>
                                </Col>
                            </Row>
                        </Row>
                        <div className="position-relative p-1 mt-1 text-start pe-none user-select-none text-dark rounded text-nowrap fw-bold border" style={{zIndex:"999", top:"0px", backgroundColor:"lightskyblue", fontSize:"small", height:"2%", width:"9%"}}>Drop Info</div>
                        <Row className="border border-secondary rounded p-2 pb-0" style={{marginTop:"-2%", backgroundColor:"#e8f9fd"}}>
                            <Row className="p-1 mx-1">
                                <Col xs={1}>
                                    <p className="fw-normal text-nowrap pe-none user-select-none" style={{fontSize:"small"}}>Street:</p>
                                    <p className="fw-normal text-nowrap pe-none user-select-none" style={{fontSize:"small"}}>Unit:</p>
                                    <p className="fw-normal text-nowrap pe-none user-select-none" style={{fontSize:"small"}}>City:</p>
                                    <p className="fw-normal text-nowrap pe-none user-select-none" style={{fontSize:"small"}}>State:</p>
                                    <p className="fw-normal text-nowrap pe-none user-select-none" style={{fontSize:"small"}}>Zip:</p>
                                    <p className="fw-normal text-nowrap pe-none user-select-none" style={{fontSize:"small"}}>Zone:</p>
                                </Col>
                                <Col xs={5}>
                                    <input type="text" value={editTripInfoManage.DOSt} onChange={(e)=>{setEditTripInfoManage({...editTripInfoManage,DOSt:e.target.value});}} className="text-start d-block rounded border-1" placeholder={state.placeholder}/>
                                    <input type="text" value={editTripInfoManage.DOUnit} onChange={(e)=>{setEditTripInfoManage({...editTripInfoManage,DOUnit:e.target.value});}} className="text-center mt-2 d-block rounded border-1" placeholder={state.placeholder}/>
                                    <input type="text" value={editTripInfoManage.DOCity} onChange={(e)=>{setEditTripInfoManage({...editTripInfoManage,DOCity:e.target.value});}} className="text-center mt-2 d-block rounded border-1" placeholder={state.placeholder}/>
                                    <input type="text" value={editTripInfoManage.DOState} onChange={(e)=>{setEditTripInfoManage({...editTripInfoManage,DOState:e.target.value});}} className="text-center mt-2 d-block rounded border-1" placeholder={state.placeholder}/>
                                    <input type="text" maxLength={5} onInput={(e)=>{e.target.value = e.target.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');}} value={isNaN(editTripInfoManage.DOZip)?"0":editTripInfoManage.DOZip} onChange={(e)=>{setEditTripInfoManage({...editTripInfoManage,DOZip:e.target.value});}} className="text-center mt-2 d-block rounded border-1" placeholder={state.placeholder}/>
                                    <input type="text" value={editTripInfoManage.DOZone} onChange={(e)=>{setEditTripInfoManage({...editTripInfoManage,DOZone:e.target.value});}} className="text-center mt-2 d-block rounded border-1" placeholder={state.placeholder}/>
                                </Col>
                                <Col xs={2}>
                                    <p className="fw-normal text-nowrap pe-none user-select-none" style={{fontSize:"small"}}>System Sch. DO Time:</p>
                                    <p className="fw-normal text-nowrap pe-none user-select-none" style={{fontSize:"small"}}>Latitude:</p>
                                    <p className="fw-normal text-nowrap pe-none user-select-none" style={{fontSize:"small"}}>Longitude:</p>
                                </Col>
                                <Col xs={4}>
                                    <input type="time" value={editTripInfoManage.DOSchTime} onChange={(e)=>{setEditTripInfoManage({...editTripInfoManage,DOSchTime:e.target.value});}} className="text-center d-block rounded border-1" placeholder={state.placeholder}/>
                                    <input type="text" value={editTripInfoManage.DOLat} onChange={(e)=>{setEditTripInfoManage({...editTripInfoManage,DOLat:e.target.value});}} className="text-center mt-2 d-block rounded border-1" placeholder={state.placeholder}/>
                                    <input type="text" value={editTripInfoManage.DOLng} onChange={(e)=>{setEditTripInfoManage({...editTripInfoManage,DOLng:e.target.value});}} className="text-center mt-2 d-block rounded border-1" placeholder={state.placeholder}/>
                                    <Button type="button" title="Verify address on google maps" disabled onClick={(e)=>{}} className="activate_btn_ok mt-2 border-0" placeholder={state.placeholder}>Verify</Button>
                                </Col>
                            </Row>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        
                        </Row>
                        <div className="position-relative p-1 mt-1 text-start pe-none user-select-none text-dark rounded text-nowrap fw-bold border" style={{zIndex:"999", top:"0px", backgroundColor:"lightskyblue", fontSize:"small", height:"2%", width:"8%"}}>Fare Info</div>
                        <Row className="border border-secondary rounded p-2 pb-0" style={{marginTop:"-2%", backgroundColor:"#e8f9fd"}}>
                            <Row className="p-1 mx-1">
                                <Col xs={2}>
                                    <p className="fw-normal text-nowrap pe-none user-select-none" style={{fontSize:"small"}}>Estimated Time:</p>
                                    <p className="fw-normal text-nowrap pe-none user-select-none" style={{fontSize:"small"}}>Estimated Distance:</p>
                                    <p className="fw-normal text-nowrap pe-none user-select-none" style={{fontSize:"small"}}>Estimated Cost:</p>
                                    <p className="fw-normal text-nowrap pe-none user-select-none" style={{fontSize:"small"}}>Copay:</p>
                                </Col>
                                <Col xs={4}>
                                    <input type="text" value={editTripInfoManage.EstTime} onChange={(e)=>{setEditTripInfoManage({...editTripInfoManage,EstTime:e.target.value});}} className="text-center d-block rounded border-1" placeholder={state.placeholder}/>
                                    <input type="text" value={editTripInfoManage.EstDist} onChange={(e)=>{setEditTripInfoManage({...editTripInfoManage,EstDist:e.target.value});}} className="text-center mt-2 d-block rounded border-1" placeholder={state.placeholder}/>
                                    <input type="text" value={editTripInfoManage.EstCost} onChange={(e)=>{setEditTripInfoManage({...editTripInfoManage,EstCost:e.target.value});}} className="text-center mt-2 d-block rounded border-1" placeholder={state.placeholder}/>
                                    <input type="text" value={editTripInfoManage.Copay} onChange={(e)=>{setEditTripInfoManage({...editTripInfoManage,Copay:e.target.value});}} className="text-center mt-2 d-block rounded border-1" placeholder={state.placeholder}/>
                                </Col>
                                <Col xs={2}>
                                    <p className="fw-normal text-nowrap pe-none user-select-none" style={{fontSize:"small"}}>Total Passengers:</p>
                                    <p className="fw-normal text-nowrap pe-none user-select-none" style={{fontSize:"small"}}>Total WheelChairs:</p>
                                    <p className="fw-normal text-nowrap pe-none user-select-none" style={{fontSize:"small"}}>Total Children:</p>
                                    <p className="fw-normal text-nowrap pe-none user-select-none" style={{fontSize:"small"}}>Funding Source:</p>
                                </Col>
                                <Col xs={4}>
                                    <input type="number" onInput={(e)=>{e.target.value = Math.abs(e.target.value);}} min={0} value={editTripInfoManage.TotPass} onChange={(e)=>{setEditTripInfoManage({...editTripInfoManage,TotPass:e.target.value});}} className="text-center d-block rounded border-1" placeholder={state.placeholder}/>
                                    <input type="number" onInput={(e)=>{e.target.value = Math.abs(e.target.value);}} min={0} value={editTripInfoManage.TotWC} onChange={(e)=>{setEditTripInfoManage({...editTripInfoManage,TotWC:e.target.value});}} className="text-center mt-2 d-block rounded border-1" placeholder={state.placeholder}/>
                                    <input type="number" onInput={(e)=>{e.target.value = Math.abs(e.target.value);}} min={0} value={editTripInfoManage.TotChildren} onChange={(e)=>{setEditTripInfoManage({...editTripInfoManage,TotChildren:e.target.value});}} className="text-center mt-2 d-block rounded border-1" placeholder={state.placeholder}/>
                                    <select defaultValue={editTripInfoManage.FS} style={{width:"82%"}} onChange={(e)=>{setEditTripInfoManage({...editTripInfoManage,FS:e.target.value});}} className="text-center d-block mt-2 rounded border-1">
                                        {FSOptionsManageHTML}
                                    </select>
                                </Col>
                            </Row>
                        </Row>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button className="activate_btn_ok mx-2 border-0" onClick={handleSaveEditTripChange}>
                            Save & Close
                        </Button>
                        
                        <Button className="activate_btn_ok mx-2 border-0" onClick={()=>setShowEditTripModal(false)}>
                            Cancel
                        </Button>
                    </Modal.Footer>
                </Modal>
            :""}
            {showUpdateSRSettingsModal ? 
            <Modal centered backdrop="static" keyboard={true} onHide={handleUpdateSettingModalOpen} show={showUpdateSRSettingsModal} animation={true}>
                <Modal.Header closeButton>
                    <Modal.Title className="pe-auto user-select-none">Update SR</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="position-relative p-1 text-start pe-none user-select-none text-secondary rounded" style={{zIndex:"9999", top:"-16px", backgroundColor:"white", fontSize:"small", height:"20px", width:"19%"}}>Day Selection</div>
                    <Row className="border border-dark rounded" style={{marginTop:"-4%"}}>
                        
                        <Row className="p-1 mx-1">
                            
                            <Col className="d-inline-flex px-1">
                                <input className="mx-1" type="checkbox" value={"Mon"} style={{cursor:"pointer"}} checked={manageDaysSelected.Mon} onChange={(e)=>{handleDayChangeofManage(e.target.value, e.target.checked)}}/><label className="user-select-none">Mon</label>
                            </Col>
                            <Col className="d-inline-flex px-1">
                                <input className="mx-1" type="checkbox" value={"Tue"} style={{cursor:"pointer"}} checked={manageDaysSelected.Tue} onChange={(e)=>{handleDayChangeofManage(e.target.value, e.target.checked)}}/><label className="user-select-none">Tue</label>
                            </Col>
                            <Col className="d-inline-flex px-1">
                                <input className="mx-1" type="checkbox" value={"Wed"} style={{cursor:"pointer"}} checked={manageDaysSelected.Wed} onChange={(e)=>{handleDayChangeofManage(e.target.value, e.target.checked)}}/><label className="user-select-none">Wed</label>
                            </Col>
                            <Col className="d-inline-flex px-1">
                                <input className="mx-1" type="checkbox" value={"Thu"} style={{cursor:"pointer"}} checked={manageDaysSelected.Thu} onChange={(e)=>{handleDayChangeofManage(e.target.value, e.target.checked)}}/><label className="user-select-none">Thu</label>
                            </Col>
                            <Col className="d-inline-flex px-1">
                                <input className="mx-1" type="checkbox" value={"Fri"} style={{cursor:"pointer"}} checked={manageDaysSelected.Fri} onChange={(e)=>{handleDayChangeofManage(e.target.value, e.target.checked)}}/><label className="user-select-none">Fri</label>
                            </Col>
                            <Col className="d-inline-flex px-1">
                                <input className="mx-1" type="checkbox" value={"Sat"} style={{cursor:"pointer"}} checked={manageDaysSelected.Sat} onChange={(e)=>{handleDayChangeofManage(e.target.value, e.target.checked)}}/><label className="user-select-none">Sat</label>
                            </Col>
                            <Col className="d-inline-flex px-1">
                                <input className="mx-1" type="checkbox" value={"Sun"} style={{cursor:"pointer"}} checked={manageDaysSelected.Sun} onChange={(e)=>{handleDayChangeofManage(e.target.value, e.target.checked)}}/><label className="user-select-none">Sun</label>
                            </Col>
                        </Row>
                    </Row>
                    <div className="position-relative p-1 text-start pe-none user-select-none text-secondary rounded text-nowrap" style={{zIndex:"999", top:"4px", backgroundColor:"white", fontSize:"small", height:"20px", width:"11%"}}>SR Info</div>
                    <Row className="border border-secondary rounded p-2">
                        <Row>
                            <Col xs={2}>
                                <p className="fw-normal text-nowrap user-select-none">Name:</p>
                                <p className="fw-normal text-nowrap user-select-none">Route:</p>
                            </Col>
                            <Col xs={5}>
                            <input type="text" className="w-100 mb-2" value={updateSRInfo.Name} onChange={(e)=>{setUpdateSRInfo({...updateSRInfo,Name:e.target.value});}}/>
                            <div title={updateSRInfo.RouteNo} className="w-100">
                            {updateSRInfo.RouteNo}
                            </div>
                                </Col>
                            <Col xs={2}>
                                <p className="fw-normal text-nowrap user-select-none">Vehicle:</p>
                            </Col>
                            <Col xs={3}>
                                <select type="text" className="w-100 text-center" defaultValue={updateSRInfo.Veh} onChange={(e)=>{setUpdateSRInfo({...updateSRInfo,Veh:e.target.value});}}>
                                    {vehOptionsManageHTML}
                                </select>
                            </Col>
                        </Row>
                    </Row>
                    <div className="position-relative p-1 text-start pe-none user-select-none text-secondary rounded text-nowrap" style={{zIndex:"999", top:"9px", backgroundColor:"white", fontSize:"small", height:"27px", width:"21%"}}>Auto Download</div>
                    <Row className="border border-secondary rounded p-2">
                        
                        <Col>
                            <p className="fw-normal text-nowrap pe-none user-select-none" style={{fontSize:"small"}}>From:</p>
                            <p className="fw-normal text-nowrap pe-none user-select-none" style={{fontSize:"small"}}>To:</p>
                            
                        </Col>
                        <Col>
                            <input type="date" className="text-center" value={updateSRInfo.From} placeholder={state.placeholder} onChange={(e)=>{setUpdateSRInfo({...updateSRInfo, From:e.target.value});}}/>
                            <input type="date" className="text-center mt-1" value={updateSRInfo.To} placeholder={state.placeholder} onChange={(e)=>{setUpdateSRInfo({...updateSRInfo, To:e.target.value});}}/>
                        </Col>
                        
                        
                        <Col xs={6}>
                            <Row>
                                <Col xs={2} className="my-1">
                                    <input type="checkbox" onChange={(e)=>{setUpdateSRInfo({...updateSRInfo, Auto:e.target.checked});}} checked={updateSRInfo.Auto} style={{cursor:"pointer"}}/>
                                </Col>
                                <Col xs={10} className="my-1">
                                    <div className="fw-bold text-nowrap pe-none user-select-none" style={{fontSize:"small"}}>Auto Download Service</div>
                                </Col>
                                
                                

                            </Row>
                            <Row>
                                <Col xs={2}>
                                    <input type="checkbox" onChange={(e)=>{setUpdateSRInfo({...updateSRInfo, InsertMissing:e.target.checked});}} checked={updateSRInfo.InsertMissing} style={{cursor:"pointer"}}/>
                                </Col>
                                <Col xs={10}>
                                    <div className="fw-bold text-nowrap pe-none user-select-none" style={{fontSize:"small"}}>Insert Missing Trips</div>
                                </Col>
                                
                            </Row>
                            
                        </Col>

                        <Row>
                            <Col xs={4}>
                                <p className="fw-normal text-nowrap pe-none user-select-none" style={{fontSize:"small"}}>SR Type:</p>
                            </Col>
                            <Col xs={8}>
                                <select defaultValue={updateSRInfo.SRType} onChange={(e)=>{setUpdateSRInfo({...updateSRInfo, SRType:e.target.value});}} className="w-100 text-center">
                                    <option value={"2"}>Locked</option>
                                    <option value={"3"}>Blocked</option>
                                    <option value={"1"}>UnLocked</option>
                                </select>
                            </Col>
                        </Row>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    
                    <Button className="activate_btn_ok border-0" onClick={handleUpdateSRSetting}>
                        Update SR
                    </Button>
                    <Button className="activate_btn_ok border-0" onClick={handleUpdateSettingModalOpen}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>: ""}
        </>
    );
}

export default StandingRoutes;
